/** Shopify CDN: Minification failed

Line 16:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 17:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 18:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 19:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 20:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 21:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 22:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 24:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 25:0 Transforming let to the configured target environment ("es5") is not supported yet
Line 26:0 Transforming let to the configured target environment ("es5") is not supported yet
... and 50 more hidden warnings

**/
// V3: Screen Printing Only Configuration
let colorsFront = [];
let colorsBack = [];
let typeOfPrint = "screen"; // V3: Always screen printing
let maxFront = 0;
let maxBack = 0;
let sleeveLeft = 0; // V3: Not used but kept for compatibility
let sleeveRight = 0; // V3: Not used but kept for compatibility
let filename = "No file chosen";

let products = [];
let saveMore = [];

let screen_printing_minimal = 24; // V3: Minimum 24 units
let dtg_minimal = 1;
let embroidery_minimal = 1;
let payload = {};
let requestPrice = 0;
let rushProduction = false; // V3: Rush production flag
let superRushProduction = false; // V4: Super Rush production flag
let rushFeePerUnit = 4.00; // V3: Rush production fee
let superRushFeePerUnit = 8.00; // V4: Super Rush production fee
let bundleConfig = null;
let bundleState = {};
const BUNDLE_DEFAULT_SIZE_KEY = 'OSFM';
let bundleActiveItemId = null;
let bundleLastChangedItemId = null;
const BUNDLE_PRIORITY = ['tumblers', 'tees', 'longsleeves', 'hoodies', 'hats'];
const ACCESSORY_KEYWORDS = ['hat', 'tumbler', 'drinkware'];
let bundleSkipAutoAdvance = false;

function isAccessoryItem(itemCfg) {
  if (!itemCfg) {
    return false;
  }
  const type = (itemCfg.type || '').toString().toLowerCase();
  const id = (itemCfg.id || '').toString().toLowerCase();
  const title = (itemCfg.title || '').toString().toLowerCase();
  return ACCESSORY_KEYWORDS.some((keyword) => type.includes(keyword) || id.includes(keyword) || title.includes(keyword));
}

function canonicalSizeToken(label) {
  const value = (label || '').toString().trim().toLowerCase();
  if (!value) {
    return null;
  }
  if (value.startsWith('xs')) {
    return 'XS';
  }
  if (value.startsWith('s') || value.includes('small')) {
    return 'S';
  }
  if (value.startsWith('m') || value.includes('medium')) {
    return 'M';
  }
  if (value.startsWith('xl') || value.includes('x-large') || value.includes('extra large')) {
    return 'XL';
  }
  if (value.startsWith('l') || (value.includes('large') && !value.includes('x-large'))) {
    return 'L';
  }
  if (value.startsWith('2x')) {
    return '2XL';
  }
  if (value.startsWith('3x')) {
    return '3XL';
  }
  return null;
}

function buildDefaultQtyTemplate(item, totalQty) {
  const sizeOptions =
    (Array.isArray(item.sizeOptions) && item.sizeOptions.length && item.sizeOptions) || [BUNDLE_DEFAULT_SIZE_KEY];
  const template = {};
  sizeOptions.forEach((size) => {
    template[size] = 0;
  });
  if (!totalQty) {
    return template;
  }

  let remaining = totalQty;
  const applyPattern = (pattern) => {
    pattern.forEach(({ token, qty }) => {
      if (!remaining) {
        return;
      }
      const match = sizeOptions.find((size) => canonicalSizeToken(size) === token);
      if (!match) {
        return;
      }
      const portion = Math.min(qty, remaining);
      template[match] = (template[match] || 0) + portion;
      remaining -= portion;
    });
  };

  if (item && item.id === 'hoodies' && totalQty === 12) {
    applyPattern([
      { token: 'S', qty: 3 },
      { token: 'M', qty: 3 },
      { token: 'L', qty: 3 },
      { token: 'XL', qty: 3 },
    ]);
  } else if (totalQty === 24) {
    applyPattern([
      { token: 'S', qty: 4 },
      { token: 'M', qty: 6 },
      { token: 'L', qty: 8 },
      { token: 'XL', qty: 6 },
    ]);
  }

  if (remaining > 0) {
    const sizeCount = sizeOptions.length;
    const base = Math.floor(remaining / sizeCount);
    const extra = remaining % sizeCount;
    sizeOptions.forEach((size, index) => {
      const addition = base + (index < extra ? 1 : 0);
      template[size] = (template[size] || 0) + addition;
    });
    remaining = 0;
  }

  return template;
}

function isBundleMode() {
  return !!(bundleConfig && Array.isArray(bundleConfig.items) && bundleConfig.items.length);
}

function buildBundlePayload() {
  if (!isBundleMode()) {
    return null;
  }
  const payload = {
    bundle_id: bundleConfig.bundleId || '',
    items: []
  };

  bundleConfig.items.forEach((itemCfg) => {
    const stateItem = bundleState[itemCfg.id];
    const selections = [];
    const isAccessory = isAccessoryItem(itemCfg);

    if (stateItem && Array.isArray(stateItem.selections)) {
      stateItem.selections.forEach((selection) => {
        selections.push({
          color: isAccessory ? '' : selection.color,
          qty: { ...selection.qty },
          total: selection.sumQty || 0
        });
      });
    }

    payload.items.push({
      id: itemCfg.id,
      title: itemCfg.title,
      minQty: itemCfg.minQty || 0,
      totalQty: stateItem ? getBundleItemTotal(stateItem) : 0,
      selections,
      patch: stateItem && stateItem.patchSelection ? { ...stateItem.patchSelection } : null
    });
  });

  return payload;
}

function buildBundleSummaryLines(bundlePayload) {
  if (!bundlePayload || !Array.isArray(bundlePayload.items)) {
    return [];
  }
  const lines = [];
  bundlePayload.items.forEach((item) => {
    (item.selections || []).forEach((selection) => {
      if (!selection.total) {
        return;
      }
      const sizeSummary = Object.keys(selection.qty || {})
        .filter((sizeKey) => selection.qty[sizeKey])
        .map((sizeKey) => `${sizeKey}: ${selection.qty[sizeKey]}`)
        .join(', ');
      lines.push(`${item.title} • ${selection.color} (${sizeSummary || 'Qty set'})`);
    });
    if (item.patch && item.patch.color) {
      const shapeLabel = item.patch.shape === 'circle' ? 'Circle' : 'Rectangle';
      const sizeLabel = item.patch.sizeLabel ? ` ${item.patch.sizeLabel}` : '';
      lines.push(`${item.title} Patch: ${item.patch.color} ${shapeLabel}${sizeLabel}`);
    }
  });
  return lines;
}

function formatMoney(value) {
  if (value === null || typeof value === 'undefined') {
    return '$0.00';
  }
  try {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(value, Shopify.money_format || '${{amount}}');
    }
  } catch (e) {}
  const parsed = typeof value === 'string' ? parseFloat(value) : value;
  const amount = isNaN(parsed) ? 0 : parsed / 100;
  return `$${amount.toFixed(2)}`;
}

function getBundleTotals() {
  const itemsTotal = products.reduce((acc, { sumQty }) => acc + (sumQty || 0), 0);
  const priceTotal = products.reduce(
    (acc, { sumQty, price }) => acc + (sumQty || 0) * (parseFloat(price) || 0),
    0
  );
  return {
    itemsTotal,
    priceTotal: Math.round(priceTotal * 100),
  };
}

function sumBundleMinimums() {
  if (!bundleConfig || !Array.isArray(bundleConfig.items)) {
    return 0;
  }
  return bundleConfig.items.reduce((acc, item) => acc + (item.minQty || 0), 0);
}

function getConfiguredCount() {
  if (!bundleConfig || !Array.isArray(bundleConfig.items)) {
    return 0;
  }
  return bundleConfig.items.reduce((count, item) => {
    const stateItem = bundleState[item.id];
    return count + (getBundleItemTotal(stateItem) >= (item.minQty || 0) ? 1 : 0);
  }, 0);
}

function renderBundleOverview() {
  if (!bundleConfig) {
    return;
  }
  const titleEl = document.getElementById('bundle-overview-title');
  const progressEl = document.getElementById('bundle-overview-progress');
  const orderEl = document.getElementById('bundle-overview-order');
  const baseEl = document.getElementById('bundle-overview-base');
  if (!titleEl) {
    return;
  }
  titleEl.textContent = bundleConfig.bundleTitle || (meta && meta.product ? meta.product.title : '');
  if (progressEl) {
    const configured = getConfiguredCount();
    const total = bundleConfig.items ? bundleConfig.items.length : 0;
    progressEl.textContent = `${configured} of ${total} products configured${configured === total ? ' ✓' : ''}`;
  }
  const totals = getBundleTotals();
  if (orderEl) {
    orderEl.textContent = `${totals.itemsTotal} items • ${formatMoney(totals.priceTotal)}`;
  }
  if (baseEl) {
    const basePrice = bundleConfig.bundleBasePrice || (meta && meta.product && meta.product.price);
    const baseItems = sumBundleMinimums();
    baseEl.textContent = `${baseItems} base items • ${formatMoney(basePrice)}`;
  }
}

function renderBundlePills() {
  const pillBar = document.getElementById('bundle-pill-bar');
  if (!pillBar || !bundleConfig || !Array.isArray(bundleConfig.items)) {
    return;
  }
  
  // Shorter product names for pills
  const shortNames = {
    'tumblers': 'Tumblers',
    'tees': 'T-Shirts',
    'longsleeves': 'Long Sleeves',
    'hoodies': 'Hoodies',
    'hats': 'Hats'
  };
  
  pillBar.innerHTML = bundleConfig.items
    .map((item, index) => {
      const stateItem = bundleState[item.id];
      const total = getBundleItemTotal(stateItem);
      const min = item.minQty || 0;
      let status = 'pending';
      if (min === 0) {
        status = total ? 'active' : 'complete';
      } else if (total >= min) {
        status = 'complete';
      } else if (bundleActiveItemId === item.id || total > 0) {
        status = 'active';
      }
      
      const shortName = shortNames[item.id] || item.title || '';
      const badge = status === 'complete' ? `${total}` : `${total}/${min}`;
      
      return `
        <button type="button" class="bundle-pill bundle-pill--${status}" data-action="open-item" data-item="${item.id}">
          <span class="bundle-pill__name">${shortName}</span>
          <span class="bundle-pill__count">${badge}</span>
        </button>
      `;
    })
    .join('');
}

function renderBundleMessage(unmet) {
  const messageEl = document.getElementById('bundle-step2-message');
  if (!messageEl) {
    return;
  }
  if (!unmet || !unmet.length) {
    messageEl.innerHTML = 'All products meet the minimum. Feel free to add more or continue to pricing.';
    messageEl.removeAttribute('role');
    messageEl.removeAttribute('tabindex');
    messageEl.removeAttribute('data-action');
    messageEl.removeAttribute('data-missing-targets');
    messageEl.classList.remove('is-clickable');
    return;
  }
  const remaining = unmet.length;
  const listMarkup = unmet
    .map(
      (item) => `
        <li>
          <button
            type="button"
            class="bundle-step2-message__link"
            data-action="open-item"
            data-item="${item.id}"
          >
            ${item.title}: need ${item.remaining}
          </button>
        </li>
      `
    )
    .join('');

  messageEl.innerHTML = `
    <p class="bundle-step2-message__headline">You're almost there! Complete ${remaining} more ${
      remaining === 1 ? 'product' : 'products'
    } to see your custom price.</p>
    <p class="bundle-step2-message__subhead">Complete each product minimum to continue:</p>
    <ul class="bundle-step2-message__list">
      ${listMarkup}
    </ul>
  `;
  messageEl.setAttribute('role', 'button');
  messageEl.setAttribute('tabindex', '0');
  messageEl.dataset.action = 'jump-to-missing';
  messageEl.dataset.missingTargets = JSON.stringify(unmet.map((item) => item.id));
  messageEl.classList.add('is-clickable');
}

function getNextIncompleteItemId(currentId) {
  if (!bundleConfig || !Array.isArray(bundleConfig.items)) {
    return null;
  }
  const ids = bundleConfig.items.map((item) => item.id);
  const startIndex = currentId ? ids.indexOf(currentId) + 1 : 0;
  const search = [...ids.slice(startIndex), ...ids.slice(0, startIndex)];
  return search.find((id) => {
    const stateItem = bundleState[id];
    return stateItem && getBundleItemTotal(stateItem) < (stateItem.minQty || 0);
  }) || null;
}

function getNextItemId(currentId) {
  if (!bundleConfig || !Array.isArray(bundleConfig.items) || !bundleConfig.items.length) {
    return null;
  }
  const ids = bundleConfig.items.map((item) => item.id);
  if (!currentId) {
    return ids[0];
  }
  const index = ids.indexOf(currentId);
  if (index === -1) {
    return ids[0];
  }
  return ids[(index + 1) % ids.length];
}

function openBundleItem(itemId, options = {}) {
  if (!itemId || !bundleState[itemId]) {
    bundleActiveItemId = null;
  } else {
    bundleActiveItemId = itemId;
  }
  renderBundleGrid();
  if (options.scroll) {
    scrollBundleIntoView(itemId);
  }
}

function autoAdvanceFrom(itemId, opts = {}) {
  const next = getNextIncompleteItemId(itemId);
  if (next) {
    openBundleItem(next, { scroll: true });
    return;
  }
  if (bundleActiveItemId === itemId || opts.force) {
    openBundleItem(null);
  }
}

function skipBundleItem(itemId) {
  const next = getNextItemId(itemId);
  if (next && next !== itemId) {
    openBundleItem(next, { scroll: true });
  } else {
    openBundleItem(null);
  }
}

function scrollBundleIntoView(itemId) {
  if (!itemId) {
    return;
  }
  const card = document.querySelector(`.bundle-card[data-bundle-item="${itemId}"]`);
  if (card) {
    card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function buildSelectionSummary(selection) {
  if (!selection) {
    return '';
  }
  const sizeParts = Object.keys(selection.qty || {})
    .filter((key) => selection.qty[key])
    .map((key) => `${key}-(${selection.qty[key]})`);
  return `${selection.color || ''}${sizeParts.length ? ' • ' + sizeParts.join(', ') : ''}`;
}

function buildSelectionSummaryList(item) {
  if (!item || !Array.isArray(item.selections) || !item.selections.length) {
    return 'No selections yet';
  }
  return item.selections.map((selection) => buildSelectionSummary(selection)).join(' + ');
}

function buildPatchSummary(item) {
  if (!item || !item.patchSelection) {
    return '';
  }
  const patch = item.patchSelection;
  const shapeLabel = patch.shape === 'circle' ? 'Circle' : 'Rectangle';
  const sizeLabel = patch.sizeLabel ? ` ${patch.sizeLabel}` : '';
  const colorLabel = patch.color ? `${patch.color} ` : '';
  return `${colorLabel}${shapeLabel}${sizeLabel}`.trim();
}

function getBundleItemProgress(item) {
  if (!item) {
    return { total: 0, min: 0, pct: 0 };
  }
  const min = item.minQty || 0;
  const total = getBundleItemTotal(item);
  const pct = min ? Math.min(100, Math.round((total / min) * 100)) : 100;
  return { total, min, pct };
}

function normalizeBundleConfig(config) {
  if (!config || !Array.isArray(config.items)) {
    return config;
  }
  config.items.sort((a, b) => {
    const indexA = BUNDLE_PRIORITY.indexOf(a.id);
    const indexB = BUNDLE_PRIORITY.indexOf(b.id);
    return (indexA === -1 ? BUNDLE_PRIORITY.length : indexA) - (indexB === -1 ? BUNDLE_PRIORITY.length : indexB);
  });
  config.sortedIds = config.items.map((item) => item.id);
  return config;
}

function captureBundleUIState(activeElement) {
  const modalBody = document.querySelector('#modal .modal-body');
  const gridEl = document.getElementById('bundle-builder-grid');
  let caret = null;
  if (activeElement && typeof activeElement.selectionStart === 'number') {
    caret = activeElement.selectionStart;
  } else if (activeElement && typeof activeElement.value === 'string') {
    caret = activeElement.value.length;
  }
  return {
    modalScroll: modalBody ? modalBody.scrollTop : null,
    gridScroll: gridEl ? gridEl.scrollTop : null,
    focus: activeElement && activeElement.getAttribute
      ? {
          selectionId: activeElement.getAttribute('data-selection'),
          itemId: activeElement.getAttribute('data-item'),
          sizeKey: activeElement.getAttribute('data-size'),
          caret: caret,
        }
      : null,
  };
}

function restoreBundleUIState(state) {
  if (!state) {
    return;
  }
  requestAnimationFrame(() => {
    if (state.gridScroll !== null) {
      const gridEl = document.getElementById('bundle-builder-grid');
      if (gridEl) {
        gridEl.scrollTop = state.gridScroll;
      }
    }
    if (state.modalScroll !== null) {
      const modalBody = document.querySelector('#modal .modal-body');
      if (modalBody) {
        modalBody.scrollTop = state.modalScroll;
      }
    }
    if (state.focus && state.focus.selectionId && state.focus.sizeKey) {
      const selector = `.bundle-size-input input[data-selection="${state.focus.selectionId}"][data-size="${state.focus.sizeKey}"]`;
      const newInput = document.querySelector(selector);
      if (newInput) {
        newInput.focus();
        if (typeof state.focus.caret === 'number') {
          newInput.setSelectionRange(state.focus.caret, state.focus.caret);
        } else {
          const len = newInput.value ? newInput.value.length : 0;
          newInput.setSelectionRange(len, len);
        }
      }
    }
  });
}

// V3: Override minimal from product metafield if provided
if (typeof window !== 'undefined' && typeof productMinimum !== 'undefined' && productMinimum !== '') {
  var parsedMinimum = parseInt(productMinimum);
  if (!isNaN(parsedMinimum) && parsedMinimum > 0) {
    screen_printing_minimal = parsedMinimum;
  }
}

//
//
//
//
//
//
//
// Set Ink / Thread Colors
// function setInkColor(color, name, side, el) {
//   if (el.classList.contains("active")) {
//     if (side === "front") {
//       const filteredColors = colorsFront.filter((item) => item.color !== color);
//       colorsFront = filteredColors;
//     } else if (side === "back") {
//       const filteredColors = colorsBack.filter((item) => item.color !== color);
//       colorsBack = filteredColors;
//     }
//     el.classList.remove("active");
//   } else {
//     if (side === "front" && maxFront > colorsFront.length) {
//       colorsFront.push({ color, name });
//       el.classList.add("active");
//     } else if (side === "back" && maxBack > colorsBack.length) {
//       colorsBack.push({ color, name });
//       el.classList.add("active");
//     }
//   }

// if (
//   colorsFront.length === parseInt(maxFront) &&
//   colorsBack.length === parseInt(maxBack)
// ) {
//   document.getElementById("step2-btn").disabled = false;
//   document.getElementById("pills-qty-tab").disabled = false;
//   document.getElementById("step2-error-text").style.display = "none";
// } else {
//   document.getElementById("step2-btn").disabled = true;
//   document.getElementById("pills-qty-tab").disabled = true;
//   document.getElementById("step2-error-text").style.display = "block";
// }
//   drawSelectedColors(colorsFront, colorsBack);
// }

// function drawSelectedColors(colorsFront, colorsBack) {
//   const elementFront = document.getElementById("selected-ink-front");
//   const elementBack = document.getElementById("selected-ink-back");
//   elementFront.innerHTML = "";
//   elementBack.innerHTML = "";

//   colorsFront.map(
//     (item) =>
//       (elementFront.innerHTML += `<div class="selected-color-item"><span class="color-item active" style="background-color: ${item.color}"></span> ${item.name}</div>`)
//   );
//   colorsBack.map(
//     (item) =>
//       (elementBack.innerHTML += `<div class="selected-color-item"><span class="color-item active" style="background-color: ${item.color}"></span> ${item.name}</div>`)
//   );
// }

//
//
//
//
//
//
//
function initializeBundleBuilder() {
  const configEl = document.getElementById('bundle_config');
  const gridEl = document.getElementById('bundle-builder-grid');
  const emptyEl = document.getElementById('bundle-builder-empty');
  const pillBarEl = document.getElementById('bundle-pill-bar');
  const messageEl = document.getElementById('bundle-step2-message');

  if (!gridEl) {
    return;
  }

  if (!configEl) {
    if (emptyEl) {
      emptyEl.innerHTML = '<p>This product is currently configured for a single-style quote. Contact support to enable bundle pricing.</p>';
    }
    return;
  }

  try {
    bundleConfig = JSON.parse(configEl.textContent);
  } catch (error) {
    console.error('V4: Unable to parse bundle configuration', error);
    if (emptyEl) {
      emptyEl.innerHTML = '<p>Something went wrong while loading bundle items. Please refresh and try again.</p>';
    }
    return;
  }

  bundleConfig = normalizeBundleConfig(bundleConfig);
  bundleState = buildBundleStateFromConfig(bundleConfig);

  if (!Object.keys(bundleState).length) {
    if (emptyEl) {
      emptyEl.innerHTML = '<p>No bundle items were found for this product.</p>';
    }
    return;
  }

  if (emptyEl) {
    emptyEl.style.display = 'none';
  }

  renderBundleGrid();
  gridEl.addEventListener('click', handleBundleGridClick);
  gridEl.addEventListener('input', handleBundleGridInput, true);
  if (pillBarEl) {
    pillBarEl.addEventListener('click', handleBundleGridClick);
  }
  if (messageEl) {
    messageEl.addEventListener('click', handleBundleGridClick);
  }
  syncProductsFromBundleState();
}

function buildBundleStateFromConfig(config) {
  const state = {};
  if (!config || !Array.isArray(config.items)) {
    return state;
  }

  config.items.forEach((item) => {
    if (!item || !item.id) {
      return;
    }

    const sizeOptions = getBundleSizeOptions(item);
    const colorSwatches = buildBundleColorSwatches(item, sizeOptions);
    const swatchMap = {};
    colorSwatches.forEach((swatch) => {
      swatchMap[swatch.key] = swatch;
    });

    const isQuantityOnly = (item.type || '').toLowerCase() === 'tumbler' || item.variantMode === 'quantity_only';
    const quantityStep = parseInt(item.quantityStep || item.quantity_step || 1, 10) || 1;

    state[item.id] = {
      ...item,
      sizeOptions,
      colorSwatches: isQuantityOnly ? [] : colorSwatches,
      colorSwatchMap: swatchMap,
      selections: [],
      patchSelection: item.patchOptions && item.patchOptions.length ? item.patchOptions[0] : null,
      collapsed: false,
      activeColorKey: null,
      isQuantityOnly,
      quantityStep,
      quantityKey: null,
    };

    if (isQuantityOnly) {
      const quantityKey = (sizeOptions && sizeOptions[0]) || BUNDLE_DEFAULT_SIZE_KEY;
      const qtyTemplate = {};
      const defaultQty = parseInt(item.defaultQuantity || item.default_quantity || item.minQty || 0, 10) || 0;
      qtyTemplate[quantityKey] = defaultQty;
      const defaultVariant =
        item.product && Array.isArray(item.product.variants) && item.product.variants.length
          ? item.product.variants[0]
          : null;
      const defaultImage =
        formatBundleImage(
          (defaultVariant && defaultVariant.featured_image) ||
            item.image ||
            (item.product && item.product.featured_image) ||
            ''
        );
      state[item.id].selections = [
        {
          id: `${item.id}-quantity`,
          color: (item.colorOptions && item.colorOptions[0]) || item.title || 'Selection',
          image: defaultImage,
          qty: qtyTemplate,
          variantMap: defaultVariant ? { [quantityKey]: defaultVariant.id } : {},
          sumQty: defaultQty,
        },
      ];
      state[item.id].quantityKey = quantityKey;
    }
    applyDefaultSelection(state[item.id]);
  });

  return state;
}

function applyDefaultSelection(item) {
  if (!item || item.isQuantityOnly) {
    return;
  }
  const minQty = item.minQty || 0;
  if (!minQty || (Array.isArray(item.selections) && item.selections.length)) {
    return;
  }
  const swatch = (item.colorSwatches && item.colorSwatches[0]) || null;
  if (!swatch) {
    return;
  }
  const qtyTemplate = buildDefaultQtyTemplate(item, minQty);
  const sumQty = Object.values(qtyTemplate).reduce((acc, val) => acc + (parseInt(val, 10) || 0), 0);
  item.selections = [
    {
      id: `${item.id}-default`,
      color: swatch.label,
      image: swatch.image,
      qty: qtyTemplate,
      variantMap: swatch.variantMap || {},
      sumQty: sumQty,
      isDefault: true,
    },
  ];
  item.activeColorKey = swatch.key;
}

function getBundleSizeOptions(item) {
  if (Array.isArray(item.sizeOptions) && item.sizeOptions.length) {
    return item.sizeOptions;
  }

  const optionName = item.optionMap && item.optionMap.size ? item.optionMap.size : 'Size';
  if (Array.isArray(item.optionsWithValues)) {
    const option = item.optionsWithValues.find((opt) => opt.name === optionName);
    if (option && Array.isArray(option.values) && option.values.length) {
      return option.values;
    }
  }
  return [BUNDLE_DEFAULT_SIZE_KEY];
}

function buildBundleColorSwatches(item, sizeOptions) {
  const swatches = [];
  if (!item.product || !Array.isArray(item.product.options) || !Array.isArray(item.product.variants)) {
    if (Array.isArray(item.colorOptions) && item.colorOptions.length) {
      item.colorOptions.forEach((colorValue) => {
        swatches.push({
          label: colorValue,
          key: slugify(colorValue),
          image: item.image || '',
          variantMap: {},
        });
      });
    }
    return swatches;
  }

  const colorName = item.optionMap && item.optionMap.color ? item.optionMap.color : 'Color';
  const colorIndex = item.product.options.indexOf(colorName);
  if (colorIndex === -1) {
    return swatches;
  }

  const sizeName = item.optionMap && item.optionMap.size ? item.optionMap.size : null;
  const sizeIndex = sizeName ? item.product.options.indexOf(sizeName) : -1;

  const map = {};
  (item.product.variants || []).forEach((variant) => {
    const colorValue = variant['option' + (colorIndex + 1)];
    if (!colorValue) {
      return;
    }
    if (!map[colorValue]) {
      map[colorValue] = {
        label: colorValue,
        key: slugify(colorValue),
        image: formatBundleImage(variant.featured_image) ||
          item.image ||
          (item.product.featured_image && formatBundleImage(item.product.featured_image)) ||
          '',
        variantMap: {},
      };
    }
    const sizeValue = sizeIndex > -1 ? (variant['option' + (sizeIndex + 1)] || BUNDLE_DEFAULT_SIZE_KEY) : BUNDLE_DEFAULT_SIZE_KEY;
    map[colorValue].variantMap[sizeValue] = variant.id;
  });

  if (!Object.keys(map).length) {
    const fallbackVariant = (item.product.variants || [])[0];
    const fallbackLabel = item.defaultColor || (item.colorOptions && item.colorOptions[0]) || 'Default';
    map[fallbackLabel] = {
      label: fallbackLabel,
      key: slugify(fallbackLabel),
      image: formatBundleImage(fallbackVariant && fallbackVariant.featured_image) || item.image || '',
      variantMap: {},
    };
    const sizeList = Array.isArray(sizeOptions) && sizeOptions.length ? sizeOptions : [BUNDLE_DEFAULT_SIZE_KEY];
    sizeList.forEach((sizeKey) => {
      map[fallbackLabel].variantMap[sizeKey] = fallbackVariant ? fallbackVariant.id : null;
    });
  }

  return Object.values(map);
}

function slugify(text) {
  return (text || '')
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '') || 'option';
}

function formatBundleImage(imageObjOrUrl) {
  if (!imageObjOrUrl) {
    return '';
  }
  if (typeof imageObjOrUrl === 'string') {
    return imageObjOrUrl;
  }
  if (imageObjOrUrl.src) {
    return imageObjOrUrl.src;
  }
  return '';
}

function renderBundleGrid() {
  const gridEl = document.getElementById('bundle-builder-grid');
  if (!gridEl) {
    return;
  }
  const orderedIds = bundleConfig && Array.isArray(bundleConfig.items)
    ? bundleConfig.items.map((item) => item.id)
    : Object.keys(bundleState);
  if (bundleActiveItemId && !orderedIds.includes(bundleActiveItemId)) {
    bundleActiveItemId = null;
  }
  gridEl.innerHTML = orderedIds
    .map((key) => (bundleState[key] ? bundleCardTemplate(bundleState[key]) : ''))
    .join('');
}

function bundleCardTemplate(item) {
  const progress = getBundleItemProgress(item);
  const isActive = bundleActiveItemId === item.id;
  const statusText =
    progress.total >= progress.min && progress.min > 0
      ? `<span class="bundle-status bundle-status--ready">Ready ✓</span>`
      : `<span class="bundle-status bundle-status--pending">${progress.min ? `${progress.min} minimum` : 'Add quantities'}</span>`;

  const summaryActions = `
    <div class="bundle-card__summary-actions">
      <button type="button" class="btn-customize" data-action="customize-item" data-item="${item.id}">Edit</button>
    </div>
  `;
  const patchSummary = buildPatchSummary(item);

  const summaryHtml = `
    <div class="bundle-card__summary">
      <div>
        <strong>${progress.total || progress.min || 0} units</strong>
        <small>${buildSelectionSummaryList(item)}</small>
        ${patchSummary ? `<small class="bundle-card__patch-summary">Patch: ${patchSummary}</small>` : ''}
      </div>
      ${summaryActions}
    </div>
  `;

  const colorHtml = item.isQuantityOnly
    ? ''
    : `<div class="bundle-card__colors">
        ${(item.colorSwatches || []).map((swatch) => bundleSwatchTemplate(item, swatch)).join('')}
      </div>`;
  const patchHtml = item.isQuantityOnly ? '' : bundlePatchTemplate(item);
  const selectionsHtml = item.isQuantityOnly
    ? bundleQuantityOnlyTemplate(item, progress)
    : `<div class="bundle-card__selections">${
        item.selections.length
          ? item.selections.map((selection) => bundleSelectionTemplate(item, selection)).join('')
          : '<p class="bundle-selection__empty text-muted">Select a color above to add sizes.</p>'
      }</div>`;

  const helperText =
    progress.total >= progress.min && progress.min
      ? 'Minimum met ✓ Add more if you\'d like'
      : progress.min
      ? `Select at least ${progress.min}`
      : 'Add sizes';

  const progressBar = `
    <div class="bundle-card__progress">
      <div class="bundle-card__progress-label">
        <span>${progress.min ? `${progress.total} of ${progress.min} selected` : `${progress.total} selected`}</span>
        <span>${helperText}</span>
      </div>
      <div class="bundle-progress-bar">
        <span style="width:${progress.min ? Math.min(100, (progress.total / progress.min) * 100) : 100}%"></span>
      </div>
    </div>
  `;

  const bodySections = [progressBar];
  if (colorHtml) {
    bodySections.push(colorHtml);
  }
  if (patchHtml) {
    bodySections.push(patchHtml);
  }
  bodySections.push(selectionsHtml);
  const canAdvance = progress.min ? progress.total >= progress.min : true;

  const actions = `
    <div class="bundle-card__actions">
      <button type="button" class="btn-skip" data-action="skip-item" data-item="${item.id}">Skip for now</button>
      <button type="button" class="btn-continue" data-action="next-item" data-item="${item.id}" ${canAdvance ? '' : 'disabled'}>Next product</button>
    </div>
  `;

  return `
    <div class="bundle-card ${isActive ? '' : 'is-collapsed'}" data-bundle-item="${item.id}">
      <div class="bundle-card__header">
        <div>
          <strong>${item.title || ''}</strong>
          <div class="bundle-card__meta">${item.minQty ? `${item.minQty} unit minimum — add more for volume savings` : 'Optional add-on'}${item.subtitle ? ` • ${item.subtitle}` : ''}</div>
        </div>
        <div class="bundle-card__header-actions">
          ${statusText}
          <button
            type="button"
            class="bundle-card__toggle"
            data-action="${isActive ? 'toggle-collapse' : 'customize-item'}"
            data-item="${item.id}"
            aria-label="Toggle ${item.title}"
          >
            <span class="material-symbols-outlined">${isActive ? 'expand_less' : 'expand_more'}</span>
          </button>
        </div>
      </div>
      ${isActive ? `<div class="bundle-card__body">${bodySections.join('')}${actions}</div>` : summaryHtml}
    </div>
  `;
}

function bundleSwatchTemplate(item, swatch) {
  const isActive = item.activeColorKey === swatch.key;
  return `
    <button
      type="button"
      class="bundle-color-swatch ${isActive ? 'bundle-color-swatch--active' : ''}"
      data-action="add-color"
      data-item="${item.id}"
      data-color-key="${swatch.key}"
      title="Add ${swatch.label}"
    >
      <span class="bundle-color-swatch__chip" style="background-image:url('${swatch.image || ''}');"></span>
      <span>${swatch.label}</span>
    </button>
  `;
}

function bundleSelectionTemplate(item, selection) {
  const sizeInputs = Object.keys(selection.qty)
    .map((sizeKey) => {
      return `
        <div class="bundle-size-input">
          <label>${sizeKey}</label>
          <input
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="off"
            value="${selection.qty[sizeKey]}"
            data-action="size-input"
            data-selection="${selection.id}"
            data-item="${item.id}"
            data-size="${sizeKey}"
          />
        </div>
      `;
    })
    .join('');

  return `
    <div class="bundle-selection" data-selection-id="${selection.id}">
      <div class="bundle-selection__header">
        <div class="bundle-selection__color">
          <img src="${selection.image || item.image || ''}" alt="${selection.color}" loading="lazy" />
          <div>
            <strong>${selection.color}</strong>
            <div class="text-muted">${selection.sumQty} units</div>
          </div>
        </div>
        <button
          type="button"
          class="bundle-selection__remove"
          data-action="remove-selection"
          data-selection="${selection.id}"
          data-item="${item.id}"
          aria-label="Remove ${selection.color}"
        >
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="bundle-selection__sizes">
        ${sizeInputs}
      </div>
    </div>
  `;
}

function bundlePatchTemplate(item) {
  if (!Array.isArray(item.patchOptions) || !item.patchOptions.length || item.isQuantityOnly) {
    return '';
  }
  const options = item.patchOptions
    .map((option) => {
      const isActive = item.patchSelection && item.patchSelection.id === option.id;
      return `
        <label
          class="bundle-patch-option ${isActive ? 'is-active' : ''}"
          data-action="select-patch"
          data-item="${item.id}"
          data-patch-id="${option.id}"
          tabindex="0"
        >
          <img src="${option.image}" alt="${option.color} ${option.shape}" loading="lazy" />
          <span>${option.color} • ${option.shape === 'circle' ? 'Circle' : 'Rectangle'} ${option.sizeLabel || ''}</span>
        </label>
      `;
    })
    .join('');

  return `
    <div class="bundle-card__patch">
      <p class="bundle-card__patch-label">Pick your leather patch</p>
      <div class="bundle-card__patch-grid">
        ${options}
      </div>
    </div>
  `;
}

function bundleQuantityOnlyTemplate(item, progress = { total: 0, min: 0 }) {
  if (!item || !item.isQuantityOnly || !item.selections.length) {
    return '';
  }
  const selection = item.selections[0];
  const sizeKey = item.quantityKey || Object.keys(selection.qty || {})[0];
  const step = item.quantityStep || 1;
  const value = selection.qty[sizeKey] || 0;
  const minCopy = item.minQty ? `${item.minQty} minimum` : 'Add quantity';
  const helper = progress.min
    ? progress.total >= progress.min
      ? `Minimum met ✓ Add more if you'd like`
      : `${progress.total} of ${progress.min} selected`
    : `${progress.total} selected`;
  return `
    <div class="bundle-qty-only">
      <label class="bundle-qty-only__label">${minCopy}</label>
      <p class="text-muted">${helper}</p>
      <div class="bundle-qty-only__control">
        <button
          type="button"
          data-action="qty-step"
          data-item="${item.id}"
          data-selection="${selection.id}"
          data-size="${sizeKey}"
          data-direction="-1"
        >-</button>
        <input
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          autocomplete="off"
          value="${value}"
          data-action="size-input"
          data-selection="${selection.id}"
          data-item="${item.id}"
          data-size="${sizeKey}"
        />
        <button
          type="button"
          data-action="qty-step"
          data-item="${item.id}"
          data-selection="${selection.id}"
          data-size="${sizeKey}"
          data-direction="1"
        >+</button>
      </div>
    </div>
  `;
}

function handleBundleGridClick(event) {
  const actionEl = event.target.closest('[data-action]');
  if (!actionEl) {
    return;
  }
  const action = actionEl.getAttribute('data-action');
  const itemId = actionEl.getAttribute('data-item');

  switch (action) {
    case 'add-color':
      addBundleSelection(itemId, actionEl.getAttribute('data-color-key'));
      break;
    case 'remove-selection':
      removeBundleSelection(itemId, actionEl.getAttribute('data-selection'));
      break;
    case 'select-patch':
      selectBundlePatch(itemId, actionEl.getAttribute('data-patch-id'));
      break;
    case 'customize-item':
    case 'open-item':
      openBundleItem(itemId, { scroll: true });
      break;
    case 'toggle-collapse':
      toggleBundleCollapse(itemId);
      break;
    case 'skip-item':
      skipBundleItem(itemId);
      break;
    case 'next-item':
      autoAdvanceFrom(itemId, { force: true });
      break;
    case 'jump-to-missing': {
      const targets = actionEl.getAttribute('data-missing-targets');
      let ids = [];
      try {
        ids = JSON.parse(targets);
      } catch (e) {
        ids = [];
      }
      if (ids.length) {
        openBundleItem(ids[0], { scroll: true });
      } else {
        const next = getNextIncompleteItemId();
        if (next) {
          openBundleItem(next, { scroll: true });
        }
      }
      break;
    }
    case 'qty-step':
      stepBundleQuantity(
        itemId,
        actionEl.getAttribute('data-selection'),
        actionEl.getAttribute('data-size'),
        parseInt(actionEl.getAttribute('data-direction'), 10) || 1
      );
      break;
    default:
      break;
  }
}

function handleBundleGridInput(event) {
  const action = event.target.getAttribute('data-action');
  if (action !== 'size-input') {
    return;
  }
  const uiState = captureBundleUIState(event.target);
  const itemId = event.target.getAttribute('data-item');
  const selectionId = event.target.getAttribute('data-selection');
  const sizeKey = event.target.getAttribute('data-size');
  const rawValue = (event.target.value || '').replace(/[^\d]/g, '');
  event.target.value = rawValue;
  const value = rawValue === '' ? 0 : parseInt(rawValue, 10);

  const selection = findBundleSelection(itemId, selectionId);
  if (!selection) {
    return;
  }

  bundleSkipAutoAdvance = true;
  selection.qty[sizeKey] = value;
  selection.sumQty = Object.values(selection.qty).reduce((acc, qty) => acc + (parseInt(qty, 10) || 0), 0);
  bundleLastChangedItemId = itemId;
  renderBundleGrid();
  syncProductsFromBundleState();
  restoreBundleUIState(uiState);
}

function addBundleSelection(itemId, swatchKey) {
  const item = bundleState[itemId];
  if (!item || item.isQuantityOnly || !item.colorSwatchMap[swatchKey]) {
    return;
  }
  const swatch = item.colorSwatchMap[swatchKey];
  if (item.activeColorKey === swatchKey && item.selections.length) {
    return;
  }
  const previousSelection = item.selections.length ? item.selections[0] : null;
  const carryQty = previousSelection ? previousSelection.sumQty || 0 : item.minQty || 0;
  const qtyTemplate = previousSelection
    ? Object.keys(previousSelection.qty || {}).reduce((acc, key) => {
        acc[key] = parseInt(previousSelection.qty[key], 10) || 0;
        return acc;
      }, {})
    : buildDefaultQtyTemplate(item, carryQty);
  const sumQty = Object.values(qtyTemplate).reduce((acc, val) => acc + (parseInt(val, 10) || 0), 0);

  const selection = {
    id: `${itemId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    color: swatch.label,
    image: swatch.image,
    qty: qtyTemplate,
    variantMap: swatch.variantMap || {},
    sumQty: sumQty,
  };

  const uiState = captureBundleUIState();
  item.selections = [selection];
  item.activeColorKey = swatch.key;
  bundleActiveItemId = itemId;
  bundleLastChangedItemId = itemId;
  bundleSkipAutoAdvance = true;
  renderBundleGrid();
  syncProductsFromBundleState();
  restoreBundleUIState(uiState);
}

function removeBundleSelection(itemId, selectionId) {
  const item = bundleState[itemId];
  if (!item) {
    return;
  }
  const uiState = captureBundleUIState();
  item.selections = item.selections.filter((selection) => selection.id !== selectionId);
  if (!item.selections.length) {
    item.activeColorKey = null;
  }
  bundleLastChangedItemId = itemId;
  renderBundleGrid();
  syncProductsFromBundleState();
  restoreBundleUIState(uiState);
}

function selectBundlePatch(itemId, patchId) {
  const item = bundleState[itemId];
  if (!item || !Array.isArray(item.patchOptions)) {
    return;
  }
  const selected = item.patchOptions.find((patch) => patch.id === patchId);
  if (!selected) {
    return;
  }
  const uiState = captureBundleUIState();
  item.patchSelection = selected;
  bundleSkipAutoAdvance = true;
  bundleLastChangedItemId = itemId;
  renderBundleGrid();
  syncProductsFromBundleState();
  restoreBundleUIState(uiState);
}

function toggleBundleCollapse(itemId) {
  const uiState = captureBundleUIState();
  if (bundleActiveItemId === itemId) {
    bundleActiveItemId = null;
  } else {
    bundleActiveItemId = itemId;
  }
  renderBundleGrid();
  restoreBundleUIState(uiState);
}

function stepBundleQuantity(itemId, selectionId, sizeKey, direction) {
  const item = bundleState[itemId];
  if (!item || !item.isQuantityOnly) {
    return;
  }
  const selection = findBundleSelection(itemId, selectionId);
  if (!selection) {
    return;
  }
  const qtyKey = sizeKey || item.quantityKey || Object.keys(selection.qty || {})[0];
  const step = item.quantityStep || 1;
  const newValue = Math.max(0, (selection.qty[qtyKey] || 0) + step * direction);
  selection.qty[qtyKey] = newValue;
  selection.sumQty = newValue;
  const uiState = captureBundleUIState();
  bundleSkipAutoAdvance = true;
  bundleLastChangedItemId = itemId;
  renderBundleGrid();
  syncProductsFromBundleState();
  restoreBundleUIState(uiState);
}

function findBundleSelection(itemId, selectionId) {
  const item = bundleState[itemId];
  if (!item) {
    return null;
  }
  return item.selections.find((selection) => selection.id === selectionId) || null;
}

function getBundleItemTotal(item) {
  if (!item || !Array.isArray(item.selections)) {
    return 0;
  }
  return item.selections.reduce((total, selection) => total + (selection.sumQty || 0), 0);
}

function syncProductsFromBundleState() {
  products = [];
  Object.keys(bundleState).forEach((key) => {
    const item = bundleState[key];
    if (!item || !Array.isArray(item.selections)) {
      return;
    }
    item.selections.forEach((selection) => {
      const variantEntries = [];
      Object.keys(selection.variantMap || {}).forEach((sizeKey) => {
        variantEntries.push({
          id: selection.variantMap[sizeKey],
          option1: selection.color,
          option2: sizeKey,
          price: (item.basePrice || 0) * 100,
          available: true,
        });
      });
      products.push({
        id: selection.id,
        title: item.title,
        color: selection.color,
        image: selection.image || item.image || '',
        qty: { ...selection.qty },
        variants: variantEntries,
        sumQty: selection.sumQty,
        price: parseFloat(item.basePrice || 0).toFixed(2),
        calc_price: parseFloat(item.basePrice || 0),
        bundleItemId: item.id,
        patchSelection: item.patchSelection || null,
      });
    });
  });

  const changedItemId = bundleLastChangedItemId;
  bundleLastChangedItemId = null;
  updateBundleProgressUI();
  drawProductsListReview(products);
  checkThirdStepAvailability();

  if (!bundleSkipAutoAdvance && changedItemId && bundleActiveItemId === changedItemId) {
    const stateItem = bundleState[changedItemId];
    if (stateItem && getBundleItemTotal(stateItem) >= (stateItem.minQty || 0)) {
      autoAdvanceFrom(changedItemId);
    }
  }
  bundleSkipAutoAdvance = false;
}

function updateBundleProgressUI() {
  if (!bundleConfig || !bundleConfig.items) {
    return;
  }
  const errorEl = document.getElementById('step3-error-text');
  const unmet = [];
  let firstIncompleteId = null;
  bundleConfig.items.forEach((item) => {
    const stateItem = bundleState[item.id];
    const totalQty = getBundleItemTotal(stateItem);
    if (totalQty < (item.minQty || 0)) {
      unmet.push({
        id: item.id,
        title: item.title || 'Product',
        remaining: (item.minQty || 0) - totalQty,
      });
      if (!firstIncompleteId) {
        firstIncompleteId = item.id;
      }
    }
  });

  if (errorEl) {
    errorEl.style.display = 'none';
    errorEl.innerHTML = '';
  }
  renderBundleOverview();
  renderBundlePills();
  renderBundleMessage(unmet);
  if (!bundleActiveItemId && firstIncompleteId) {
    openBundleItem(firstIncompleteId);
  }
}

//
//
//
//
//
//
//
// V3: Simplified - always screen printing
function chooseTypeOfPrint(type) {
  typeOfPrint = "screen"; // V3: Always screen printing
  
  let minqty = screen_printing_minimal;
  let t_qty = products.reduce((acc, { sumQty }) => acc + sumQty, 0);
  
  if (t_qty < minqty) {
    $("#step3-btn").attr('disabled', true);
  } else {
    $("#step3-btn").removeAttr('disabled');
  }
  
  $("#minimalqty").text(screen_printing_minimal);
  // V3: No need to change UI text since screen printing is the only option
}

function chooseColorsFront(qty) {
  maxFront = qty;
  updatePrintLocationVisibility(); // V3: Show/hide print locations
  drawProductsListReview(products);
}

function chooseColorsBack(qty) {
  maxBack = qty;
  updatePrintLocationVisibility(); // V3: Show/hide print locations
  drawProductsListReview(products);
}

function chooseSleeveLeft(qty) {
  sleeveLeft = qty;
  drawProductsListReview(products);
  /*if (parseInt($("#sleeveLeft").val()) > 0) {
        // flag = true;
        // $("#sleeveLeft").siblings().hide()
        $('select#colorFront').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
        $('select#colorBack').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
        $('select#sleeveRight').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
      }else{
        // flag = false;
        $('select#colorFront').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        $('select#colorBack').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        $('select#sleeveRight').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        // $("#sleeveLeft").siblings().show()
      }*/
}

function chooseSleeveRight(qty) {
  sleeveRight = qty;
  drawProductsListReview(products);
  	  /* if (parseInt($("#sleeveRight").val()) > 0) {
        // flag = true;
        $('select#colorFront').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
        $('select#colorBack').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
        $('select#sleeveLeft').css({"background-color": "#d1d3d6a6", "color": "#22252c7a", "pointer-events": "none"});
        // $("#sleeveRight").siblings().hide()
      }else{
        // flag = false;
         $('select#colorFront').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        $('select#colorBack').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        $('select#sleeveLeft').css({"background-color": "#fff", "color": "#22252c", "pointer-events": "all"});
        // $("#sleeveRight").siblings().show()
      }
  */
}

// V3: DTG location handlers removed - screen printing only

// V3: Print Location Visibility
function updatePrintLocationVisibility() {
  const frontColors = parseInt($("#colorFront").val()) || 0;
  const backColors = parseInt($("#colorBack").val()) || 0;
  
  // Show container if any colors selected
  if (frontColors > 0 || backColors > 0) {
    $("#print-locations-container").show();
  } else {
    $("#print-locations-container").hide();
  }
  
  // Show/hide front location
  if (frontColors > 0) {
    $("#front-location-section").show();
  } else {
    $("#front-location-section").hide();
  }
  
  // Show/hide back location
  if (backColors > 0) {
    $("#back-location-section").show();
  } else {
    $("#back-location-section").hide();
  }

  syncLocationCards();
}

// V3: Update location selector UI + hidden inputs
function setLocationValue(targetSelector, value) {
  const $input = $(targetSelector);
  if (!$input.length) {
    return;
  }
  let newValue = value;
  if (typeof newValue === 'undefined' || newValue === null || newValue === '') {
    newValue = $input.val();
  } else {
    $input.val(newValue);
  }

  updateLocationCardState(targetSelector, newValue);
}

function updateLocationCardState(targetSelector, value) {
  $('.location-card').each(function() {
    const $card = $(this);
    if ($card.data('target') === targetSelector) {
      if ($card.data('value') === value) {
        $card.addClass('active');
      } else {
        $card.removeClass('active');
      }
    }
  });
}

function syncLocationCards() {
  setLocationValue('#frontLocation', $('#frontLocation').val() || 'Full Front');
  setLocationValue('#backLocation', $('#backLocation').val() || 'Full Back');
}

$(document).on('click', '.location-card', function() {
  const targetSelector = $(this).data('target');
  const value = $(this).data('value');
  if (!targetSelector || !value) {
    return;
  }
  setLocationValue(targetSelector, value);
});

function drawColorsSelection(typeOfPrint) {
  $("#choose-colors").addClass("d-none");

  if (typeOfPrint === "screen") {
    $("#choose-colors").removeClass("d-none");
    $(".choose-print_locations, #choose-embroidery-colors").addClass("d-none");  

  } else if (typeOfPrint === "embroidery") {
    $("#choose-embroidery-colors").removeClass("d-none");
    $(".choose-print_locations, #choose-colors").addClass("d-none");  
  }
  else if (typeOfPrint === "DTG") {
    $("#choose-colors, #choose-embroidery-colors").addClass("d-none");
    $(".choose-print_locations").removeClass("d-none"); 
    
  }else {

  }
  //   drawSelectedColors(colorsFront, colorsBack);
}

//
//
//
//
//
//
//
// Adding new product on color clicked
function addColorItem(title, colorName, imageSrc, el) {
  var pData = JSON.parse(jQuery("#product_json").html());
  var colorOptionPosition = pData.options.findIndex(x=>x.toLowerCase() == "color")+1;
  var sizeOptionPosition = pData.options.findIndex(x=>x.toLowerCase() == "size")+1;
  var variants = pData.variants.filter(v => v["option"+colorOptionPosition] == colorName);
  var select_variants={};
  for (let index = 0; index < variants.length; index++) {
      select_variants[variants[index]["option"+sizeOptionPosition]]=0;
  }
  if (!el.classList.contains("active")) {
    products.push({
      id: el.id,
      title: title,
      color: colorName,
      image: imageSrc,
      qty: select_variants,
      variants:variants,
      front:maxFront,
      back:maxBack,
      sleeveLeft:0,  // V3: Not used, always 0
      sleeveRight:0, // V3: Not used, always 0
      sumQty: 0,
      price: 0.00, // PLACEHOLDER PRICE
    });

    el.classList.add("active");

    drawSelectedProducts(products);
  } else {
    const filteredProducts = products.filter((item) => item.id !== el.id);
    products = filteredProducts;

    el.classList.remove("active");
    drawSelectedProducts(products);
  }
  checkThirdStepAvailability();
}

function removeProduct(productId) {
  const filteredProducts = products.filter((item) => item.id !== productId);
  products = filteredProducts;

  document.getElementById(productId).classList.remove("active");

  checkThirdStepAvailability();
  drawSelectedProducts(products);
}

//
//
//
//
//
//
//
// Items counter on change

function countProductItems(size, el) {
  const productParent = el.closest(".products-list-item");
  const allInputs = productParent.getElementsByTagName("input");
  const allInputsArr = [...allInputs];
  const sumContainer = productParent.getElementsByClassName("product-items-qty");

  const stock = parseInt(el.getAttribute('data-inventory'));
  const newValue = parseInt(el.value); 
  console.log(stock, newValue);
  if (newValue > stock) {
    el.classList.add('error');
  }else{
    el.classList.remove('error');
  }
  const productId = productParent.dataset.productId;
  const productIndex = products.findIndex((item) => item.id == productId);

  products[productIndex].qty[size] = newValue;

  var sum = 0;
  var price = 0;
  var stockcheck = false;
  for (var i = 0; i < allInputsArr.length; i++) {
    if (parseInt(allInputsArr[i].value)) sum += parseInt(allInputsArr[i].value);
    if (parseInt(allInputsArr[i].value)) price += parseFloat(allInputsArr[i].getAttribute("data-price")) * parseInt(allInputsArr[i].value);
    if (parseInt(allInputsArr[i].value) > parseInt(allInputsArr[i].getAttribute('data-inventory'))) {
      stockcheck=true;
    }
  }

  price = (price/100)/sum;
  console.log(price);
  products[productIndex].sumQty = sum;
  products[productIndex].price = price.toFixed(2);
  products[productIndex].calc_price = price.toFixed(2);
  sumContainer[0].innerText = products[productIndex].sumQty;

  var minqty = 1;
  if (typeOfPrint == 'screen') {
    minqty = screen_printing_minimal;
  }else if (typeOfPrint == 'embroidery') {
    minqty = embroidery_minimal;
  }else if (typeOfPrint == 'DTG') {
    minqty = dtg_minimal;
  }
  let t_qty = products.reduce((acc, { sumQty }) => acc + sumQty, 0);
  if (stockcheck || t_qty < minqty) {
    $("#step3-btn").attr('disabled', true);
    return false;
  }else{
    $("#step3-btn").removeAttr('disabled');
  }


  checkThirdStepAvailability();

  drawProductsListReview(products);
  
}

function checkThirdStepAvailability() {
  if (bundleConfig && Array.isArray(bundleConfig.items) && bundleConfig.items.length) {
    const allMet = bundleConfig.items.every((item) => {
      const stateItem = bundleState[item.id];
      const totalQty = getBundleItemTotal(stateItem);
      return totalQty >= (item.minQty || 0);
    });

    if (allMet && products.length) {
      document.getElementById("step3-btn").disabled = false;
      document.getElementById("pills-review-tab").disabled = false;
    } else {
      document.getElementById("step3-btn").disabled = true;
      document.getElementById("pills-review-tab").disabled = true;
    }
    return;
  }

  var minqty = 1;
  if (typeOfPrint == 'screen') {
    minqty = screen_printing_minimal;
  }else if (typeOfPrint == 'embroidery') {
    minqty = embroidery_minimal;
  }else if (typeOfPrint == 'DTG') {
    minqty = dtg_minimal;
  }
  
  // Calculate total quantity across all products/variants
  const totalQty = products.reduce((acc, item) => acc + (item.sumQty || 0), 0);
  
  // Check if total meets minimum OR if no products selected
  const stepReviewDisabled = totalQty < minqty || products.length === 0;
  
  if (stepReviewDisabled) {
    document.getElementById("step3-btn").disabled = true;
    document.getElementById("pills-review-tab").disabled = true;
    document.getElementById("step3-error-text").style.display = "block";
  } else {
    document.getElementById("step3-btn").disabled = false;
    document.getElementById("pills-review-tab").disabled = false;
    document.getElementById("step3-error-text").style.display = "none";
  }

  if ($('.sizes .sizes-input .error').length) {
    $("#step3-btn").attr('disabled', true);
  }
}

//
//
//
//
//
//
//
// Drawing Selected products list
function drawSelectedProducts(products) {
  if (bundleConfig && Array.isArray(bundleConfig.items) && bundleConfig.items.length) {
    return;
  }
    var swatch = $('.gf_swatches-selector[data-name="Color"] .gf_swatch');
    swatch.each(function(){
        var clr = $(this).text();
        var styl = $(this).attr('style');
        $('color-item[data-color="'+clr+'"]').attr('style', styl);
    });
  productsContainer = document.getElementById("products-list");
  productsContainer.innerHTML = "";

  for (let p = 0; p < products.length; p++) {
    var item = products[p];
    var sizeview = "";
    item.variants.map((variant) => (
     sizeview += `<div class="sizes-input `+(variant.available ? '' : 'outstock')+`">
          <label>`+variant.option2+`</label>
          <input type="text" inputmode="numeric" pattern="[0-9]*" `+(variant.available ? '' : 'disabled')+` data-inventory="`+variantStock[variant.id]+`" data-variant="`+variant.id+`" data-price="`+variant.price+`" name="" id="`+variant.id+`" value="`+item.qty[variant.option2]+`" onkeyup="countProductItems('`+variant.option2+`', this)" class="`+(item.qty[variant.option2] > variantStock[variant.id] ? 'error' : '')+`" />
      </div>`
    ));

    productsContainer.innerHTML += `<div class="products-list-item" data-product-id="${item.id}">
                  <div class="remove-product">
                    <button type="button" aria-label="Remove ${item.title}" onclick="removeProduct('${item.id}')">
                      <span class="material-symbols-outlined">close</span>
                    </button>
                  </div>
                  <div class="product-card-header">
                    <div class="product-thumb">
                      <img src="${item.image}" alt="${item.title}" />
                      <div class="product-color">${item.color}</div>
                      <a class="add-sizes js-collapse-toggle" href="#" data-collapse-target="#product${item.id}" aria-expanded="true">Add Sizes</a>
                    </div>
                    <div class="product-meta">
                      <strong>${item.title}</strong>
                      <div class="product-items"><span class="product-items-qty">${item.sumQty}</span> Items</div>
                    </div>
                    <span
                      class="material-symbols-outlined js-collapse-toggle collapse-toggle"
                      data-collapse-target="#product${item.id}"
                      role="button"
                      aria-expanded="true"
                    >
                      expand_more
                    </span>
                  </div>
                  <div class="collapse-section show" id="product${item.id}">
                    <div class="sizes">
                      <strong>Sizes</strong>
                      <div class="sizes-qty">
                        `+sizeview+`
                      </div>
                    </div>
                  </div>
      </div>`
    
  }

  drawProductsListReview(products);
}

//
//
//
//
//
//
//
// Draw Products list STEP 3
function drawProductsListReview(products) {
  productsContainer = document.getElementById("products-list-review");
  if (!productsContainer) {
    return;
  }

  if (isBundleMode()) {
    productsContainer.innerHTML = renderBundleReviewCards();
    updateGrandTotal();
    return;
  }

  productsContainer.innerHTML = "";
  console.log("V3: drawProductsListReview() - products:", products);
  for (let rp = 0; rp < products.length; rp++) {
    var item = products[rp];
    var qtyview = [];
    Object.keys(item.qty).forEach(function(key) {
      item.qty[key] ? qtyview.push(key+` - <strong>${item.qty[key]}</strong>`) : ``;
    })
    qtyview = qtyview.join(" , ") || "No sizes selected";
    const screenLocations = `
      <div class="${ maxFront > 0 ? '' : 'hide' }">${maxFront} colors front - ${$("#frontLocation").val() || 'Full Front'}</div>
      <div class="${ maxBack > 0 ? '' : 'hide' }">${maxBack} colors back - ${$("#backLocation").val() || 'Full Back'}</div>
    `;
    const embroideryLocations = `
      <div class="${ $("#colorchestFront").val() > 0 ? '' : 'hide' }">${$("#colorchestFront").val()} colors Chest front</div>
      <div class="${ $("#thread_count").val() > 0 ? '' : 'hide' }">${$("#thread_count :selected").text()}</div>
    `;
    productsContainer.innerHTML += `
      <div class="product-review-card">
        <div class="review-card-thumb">
          <img src="${item.image}" alt="${item.title}" />
        </div>
        <div class="review-card-body">
          <div class="review-card-title">${item.title}</div>
          <div class="review-card-color">${item.color}</div>
          <div class="review-card-meta">
            <div>
              <div class="review-meta-label">Sizes</div>
              <div class="review-meta-value">${qtyview}</div>
              <div class="edit-sizes-link quote-tab-trigger" data-tab-target="#pills-qty">Edit Sizes</div>
            </div>
            <div>
              <div class="review-meta-label">Filename</div>
              <div class="review-meta-value">${filename || 'No file chosen'}</div>
            </div>
            <div class="${ typeOfPrint != 'screen' ? 'hide' : '' }">
              <div class="review-meta-label">Print Locations</div>
              <div class="review-meta-value">${screenLocations}</div>
            </div>
            <div class="${ typeOfPrint != 'embroidery' ? 'hide' : '' }">
              <div class="review-meta-label">Print Locations</div>
              <div class="review-meta-value">${embroideryLocations}</div>
            </div>
          </div>
        </div>
        <div class="review-card-qty">
          ${item.sumQty} Items
          <span class="unit-price">$${item.price} each</span>
          ${generateColorChargeDisplay(item.sumQty, item.price)}
        </div>
      </div>`;
  }

  let options = {
    day: "numeric",
    month: "long",
  };
  let rush = addDays(new Date(), 3);
  let free = addDays(new Date(), 14);

  // V3: Check if elements exist before updating (may not exist in all templates)
  const rushDeliveryEl = document.getElementById("rush-delivery");
  if (rushDeliveryEl) {
    rushDeliveryEl.innerHTML = rush.toLocaleDateString("en-US", options);
  }
  const freeDeliveryEl = document.getElementById("free-delivery");
  if (freeDeliveryEl) {
    freeDeliveryEl.innerHTML = free.toLocaleDateString("en-US", options);
  }

  // V3: Use updateGrandTotal to handle rush fees
  updateGrandTotal();
}

function renderBundleReviewCards() {
  if (!isBundleMode()) {
    return '';
  }
  return bundleConfig.items.map((cfg) => {
    const stateItem = bundleState[cfg.id];
    const totalQty = stateItem ? getBundleItemTotal(stateItem) : 0;
    const hasSelections = stateItem && stateItem.selections && stateItem.selections.length;
    const selectionsHtml = hasSelections
      ? stateItem.selections.map((selection) => {
          const sizeSummary = Object.keys(selection.qty || {})
            .filter((sizeKey) => selection.qty[sizeKey])
            .map((sizeKey) => `${sizeKey}: <strong>${selection.qty[sizeKey]}</strong>`)
            .join(', ');
          return `
            <div class="bundle-review-row">
              <div class="review-card-color">${selection.color}</div>
              <div class="review-meta-value">${sizeSummary || 'No sizes selected'}</div>
            </div>
          `;
        }).join('')
      : '<div class="text-muted">No selections yet.</div>';

    const patchHtml = stateItem && stateItem.patchSelection
      ? `<div class="bundle-review-patch">
          <div class="review-meta-label">Patch</div>
          <div class="review-meta-value">
            ${stateItem.patchSelection.color} • ${stateItem.patchSelection.shape === 'circle' ? 'Circle' : 'Rectangle'}
            ${stateItem.patchSelection.sizeLabel || ''}
          </div>
        </div>`
      : '';

    // Check if this is an accessory item (hats/tumblers) - no customization costs
    const isAccessory = isAccessoryItem(cfg);
    
    // Find corresponding product in products array for pricing
    const productItem = products.find(p => p.title && p.title.toLowerCase().includes(cfg.id));
    const unitPrice = productItem ? productItem.price : (cfg.basePrice || 0);
    
    // Only show unit price for apparel items (not accessories)
    const priceHtml = !isAccessory && unitPrice > 0
      ? `<span class="unit-price">$${parseFloat(unitPrice).toFixed(2)} each</span>`
      : '';
    
    // Add rush processing note for ALL items (including accessories)
    const rushNote = totalQty > 0
      ? generateColorChargeDisplay(totalQty, unitPrice)
      : '';

    return `
      <div class="product-review-card">
        <div class="review-card-thumb">
          <img src="${formatBundleImage((stateItem && stateItem.image) || cfg.image)}" alt="${cfg.title}" />
        </div>
        <div class="review-card-body">
          <div class="review-card-header">
            <div class="review-card-title">${cfg.title}</div>
            <div class="review-card-qty">
              ${totalQty} Items
              ${priceHtml}
              ${rushNote}
            </div>
          </div>
          <div class="review-card-color">${hasSelections ? '' : '<span class="text-muted">Not configured</span>'}</div>
          <div class="review-card-meta">
            <div>
              <div class="review-meta-label">Selections</div>
              <div class="review-meta-value">${selectionsHtml}</div>
              <div class="edit-sizes-link quote-tab-trigger" data-tab-target="#pills-qty">Edit</div>
            </div>
            ${patchHtml}
          </div>
        </div>
      </div>
    `;
  }).join('');
}

//
//
//
//
//
//
// Generate extra color charge display for product card
function generateColorChargeDisplay(sumQty, pricePerUnit) {
  // Calculate total colors (front + back)
  let totalColors = (parseInt(maxFront) || 0) + (parseInt(maxBack) || 0);
  let extraColors = totalColors - 1;
  
  // Build an array of what's included in the line item total
  let includedCharges = [];
  
  // V3: Extra color charge only applies if more than 1 color total
  if (extraColors > 0) {
    includedCharges.push(`+${extraColors} extra color${extraColors > 1 ? 's' : ''}`);
  }
  
  // Check if rush or super rush processing is enabled
  if (superRushProduction) {
    includedCharges.push('super rush processing');
  } else if (rushProduction) {
    includedCharges.push('rush processing');
  }
  
  // If nothing special is included, return empty
  if (includedCharges.length === 0) {
    return '';
  }
  
  // V3: Color charge and rush fee are included in the API per_unit price
  // The API calculates: base_price + (extra_colors × color_charge_per_unit) + rush_fee
  // We show this as informational note
  let chargesText = includedCharges.join(' and ');
  return `<span class="color-charge-line">(includes ${chargesText})</span>`;
}

// Count delivery dates
function addDays(theDate, days) {
  return new Date(theDate.getTime() + days * 24 * 60 * 60 * 1000);
}

// V3: Update pricing when rush production changes
function updatePricingWithRush() {
  if (products.length > 0) {
    // Recalculate pricing from API (which includes rush fee in per_unit)
    previewSaveMore();
    
    // updateGrandTotal() is called inside previewSaveMore() after API response
    // It will handle the rush fee display
  }
}

// V3: Update grand total (rush fee is already included in per_unit price from API)
function updateGrandTotal() {
  let itemsTotal = products.reduce((acc, { sumQty }) => acc + (sumQty || 0), 0);
  let priceTotal = products.reduce(
    (acc, { sumQty, price }) => acc + (sumQty || 0) * (parseFloat(price) || 0),
    0
  );
  
  // Calculate rush fee - ONLY for apparel items (not accessories like hats/tumblers)
  // Bundle items (from bundleState) might need different handling
  let apparelItemsTotal = 0;
  if (window.bundleState && window.bundleState.items) {
    // Count only apparel items from bundle
    Object.values(window.bundleState.items).forEach(item => {
      if (item && item.selections && !isAccessoryItem(item)) {
        item.selections.forEach(sel => {
          if (sel.quantities) {
            apparelItemsTotal += Object.values(sel.quantities).reduce((sum, qty) => sum + (parseInt(qty) || 0), 0);
          }
        });
      }
    });
  } else {
    // Fallback: use all items (for non-bundle products)
    apparelItemsTotal = itemsTotal;
  }
  
  // Calculate rush fee based on apparel items only
  let rushFeeTotal = 0;
  if (superRushProduction) {
    rushFeeTotal = apparelItemsTotal * superRushFeePerUnit;
  } else if (rushProduction) {
    rushFeeTotal = apparelItemsTotal * rushFeePerUnit;
  }
  
  // Your Total should be subtotal WITHOUT rush fee
  let subtotalWithoutRush = priceTotal - rushFeeTotal;
  
  // Bundle add-on (48 tumblers) if selected
  let bundleAddonTotal = 0;
  try {
    if (window.bundleAddon && $('#bundle_addon_checkbox').length && $('#bundle_addon_checkbox').is(':checked')) {
      bundleAddonTotal = (parseInt(window.bundleAddon.priceCents || 0, 10) || 0) / 100;
    }
  } catch(e) {}
  
  // Regular add-on (qty 1) if selected
  let addonTotal = 0;
  try {
    if (window.quoteAddon && $('#quote_addon').length && $('#quote_addon').is(':checked')) {
      addonTotal = (parseInt(window.quoteAddon.priceCents || 0, 10) || 0) / 100;
    }
  } catch(e) {}
  
  console.log("V4: updateGrandTotal()", {
    products: products,
    itemsTotal: itemsTotal,
    priceTotal: priceTotal,
    subtotalWithoutRush: subtotalWithoutRush,
    rushFeeTotal: rushFeeTotal,
    bundleAddonTotal: bundleAddonTotal,
    addonTotal: addonTotal
  });
  
  // Display the rush/super rush fee separately
  if (superRushProduction || rushProduction) {
    $("#rush-fee-row").show();
    if (superRushProduction) {
      $("#rush-fee-row .summary-line-label").text("Super Rush Production Fee");
    } else {
      $("#rush-fee-row .summary-line-label").text("Rush Production Fee");
    }
    $("#total-rush-fee").text(rushFeeTotal.toFixed(2));
  } else {
    $("#rush-fee-row").hide();
  }
  
  // Display Bundle Add-on row when selected
  if (bundleAddonTotal > 0) {
    $("#bundle-addon-fee-row").show();
    $("#total-bundle-addon-fee").text(bundleAddonTotal.toFixed(2));
  } else {
    $("#bundle-addon-fee-row").hide();
  }
  
  // Display Regular Add-on row when selected
  if (addonTotal > 0) {
    $("#addon-fee-row").show();
    $("#total-addon-fee").text(addonTotal.toFixed(2));
  } else {
    $("#addon-fee-row").hide();
  }
  
  // "Your Total" shows subtotal WITHOUT rush
  $("#total-items").text(itemsTotal);
  $("#total-price").text(subtotalWithoutRush.toFixed(2));
  
  // Grand total = subtotal + rush fee + addons
  let grandTotal = subtotalWithoutRush + rushFeeTotal + bundleAddonTotal + addonTotal;
  $("#grand-total").text(grandTotal.toFixed(2));
  
  // Calculate and display price per item when bundle is selected
  if (bundleAddonTotal > 0) {
    // Add 48 tumblers to the total item count
    let totalItemsWithBundle = itemsTotal + 48;
    let pricePerItem = grandTotal / totalItemsWithBundle;
    $("#price-per-item-row").show();
    $("#price-per-item").text(pricePerItem.toFixed(2));
  } else {
    $("#price-per-item-row").hide();
  }
}

//
//
//
//
//
//
//
// Preview image on file chosen
/**
 * Initialize full-screen drag-and-drop for design upload
 */
function initializeDragAndDrop() {
  const dragzone = document.getElementById('design-dragzone');
  const fileInput = document.getElementById('imageUpload');
  
  if (!dragzone || !fileInput) return;

  let dragCounter = 0;
  let isDragging = false;

  // Prevent default drag behaviors
  ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
    dragzone.addEventListener(eventName, preventDefaults, false);
  });

  function preventDefaults(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  // Highlight drop zone when item is dragged over it
  dragzone.addEventListener('dragenter', function(e) {
    dragCounter++;
    if (!isDragging) {
      isDragging = true;
      dragzone.classList.add('is-dragging');
    }
  }, false);

  dragzone.addEventListener('dragover', function(e) {
    // Keep the dragging state active
    if (!isDragging) {
      isDragging = true;
      dragzone.classList.add('is-dragging');
    }
  }, false);

  dragzone.addEventListener('dragleave', function(e) {
    dragCounter--;
    if (dragCounter === 0) {
      isDragging = false;
      dragzone.classList.remove('is-dragging');
    }
  }, false);

  dragzone.addEventListener('drop', function(e) {
    dragCounter = 0;
    isDragging = false;
    dragzone.classList.remove('is-dragging');
    
    const dt = e.dataTransfer;
    const files = dt.files;
    
    if (files && files.length > 0) {
      fileInput.files = files;
      PreviewImage();
    }
  }, false);
}

function PreviewImage() {
  jQuery(".preview_file").html('');
  filename = '';
  if (document.getElementById("imageUpload").files.length) {
    for (let pm = 0; pm < document.getElementById("imageUpload").files.length; pm++) {
      var oFReader = new FileReader();
      let u_file = document.getElementById("imageUpload").files[pm];
      oFReader.readAsDataURL(u_file);
      oFReader.onload = function (oFREvent) {
        if (u_file.type.includes('image')) {
          var imgs = `<div><img src="`+oFREvent.target.result+`" /><span data-index="`+pm+`">x</span></div>`;
          jQuery(".preview_file").append(imgs);          
        }else{
          jQuery(".preview_file").append(`<div><div class="preview_file_name">`+u_file.name+`</div><span data-index="`+pm+`">x</span></div>`);
        }

        //document.getElementById("uploadPreview").src = oFREvent.target.result;
      
        filename += document.getElementById("imageUpload").files.item(pm).name+", ";
      };
    }

    $(document).on('click', '.preview_file span', function() {
      console.log("ok...")
      removeFile($(this).data('index'))
    })

    drawProductsListReview(products);
  }
  // var oFReader = new FileReader();
  // oFReader.readAsDataURL(document.getElementById("imageUpload").files[0]);

  // oFReader.onload = function (oFREvent) {
  //   document.getElementById("uploadPreview").src = oFREvent.target.result;

  //   filename = document.getElementById("imageUpload").files.item(0).name;
  //   drawProductsListReview(products);
  // };
}

//
//
//
//
//
//
//
// Show modal by default
$(document).ready(function () {
  bindQuotePopupUI();
  initializeBundleBuilder();
  initializeDragAndDrop();
  $(".quote_open").click(function(e){
    e.preventDefault();
    prepareQuoteModalUI();
    openQuoteModal();
  });

  // V3/V4: Handle rush and super rush production selection
  $('input[name="production_speed"]').change(function() {
    const selectedSpeed = $(this).val();
    rushProduction = selectedSpeed === 'rush';
    superRushProduction = selectedSpeed === 'super_rush';
    updatePricingWithRush();
  });

  // V3: Recalculate totals when bundle add-on toggled
  $(document).on('change', '#bundle_addon_checkbox', function() {
    updateGrandTotal();
  });
  
  // V3: Recalculate totals when regular add-on toggled
  $(document).on('change', '#quote_addon', function() {
    updateGrandTotal();
  });
  // V3: Handle color selection changes to update print location visibility
  $('#colorFront').change(function() {
    var qty = parseInt($(this).val()) || 0;
    console.log('V3: Front color selection changed to:', qty);
    chooseColorsFront(qty); // This updates maxFront and calls updatePrintLocationVisibility()
  });

  $('#colorBack').change(function() {
    var qty = parseInt($(this).val()) || 0;
    console.log('V3: Back color selection changed to:', qty);
    chooseColorsBack(qty); // This updates maxBack and calls updatePrintLocationVisibility()
  });

  // V3: Initialize screen printing on load
  // Ensure minimum is taken from metafield if present
  if (typeof productMinimum !== 'undefined' && productMinimum !== '') {
    var pmReady = parseInt(productMinimum);
    if (!isNaN(pmReady) && pmReady > 0) {
      screen_printing_minimal = pmReady;
    }
  }
  chooseTypeOfPrint('screen');
  // Update inline "Minimum XX Units" if present
  var minUnitsEl = document.getElementById('min-units-text');
  if (minUnitsEl) { minUnitsEl.textContent = screen_printing_minimal; }
  // Also update step text if present
  $("#minimalqty").text(screen_printing_minimal);
  syncLocationCards();
  
  // V3: Check initial state of color dropdowns after a brief delay to ensure DOM is fully loaded
  setTimeout(function() {
    console.log('V3: Checking initial color dropdown values on page load...');
    var frontColors = parseInt($("#colorFront").val()) || 0;
    var backColors = parseInt($("#colorBack").val()) || 0;
    console.log('V3: Front colors:', frontColors);
    console.log('V3: Back colors:', backColors);
    
    // V3: Initialize maxFront and maxBack
    chooseColorsFront(frontColors);
    chooseColorsBack(backColors);
  }, 100);

  //drawSelectedProducts(products);

        function refreshCart(t) {
            $(".cart_count").empty();
            const e = $(".cart_count"),
                i = e.text() || "0";
            let o = "",
                n = "",
                a = "",
                s = "";
            const r = $("[data-cart-form]");
            let c = !1,
                d = 0,
                l = 0;
            if ((r.data("total-discount", t.total_discount), e.text(i.replace(/[0-9]+/, t.item_count)), 0 === t.item_count)) $(".js-empty-cart__message").removeClass("hidden"), r.addClass("hidden");
            else {
                $(".js-empty-cart__message").addClass("hidden"), r.removeClass("hidden");
                let e = 0,
                    i = 0;
                $.each(t.items, (t, n) => {
                    const a = n.discounts || [];
                    let s = "";
                    for (let t = 0; t < a.length; t++) {
                        const { title: e } = a[t];
                        s = `<p class="notification-discount meta">${e}</p>`;
                    }
                    const r = t + 1;
                    if (
                        ((c = !1),
                        (d = 0),
                        (l = 0),
                        (o += `<li class="mini-cart__item" data-cart-item data-line-id="${r}" data-variant-id="${n.id}"><a href="${n.url || "/cart"}">`),
                        n.image && (o += `<div class="cart_image"><img src="${n.image.replace(/(\.[^.]*)$/, "_compact$1").replace("http:", "")}" alt="${htmlEncode(n.title)}" /></div></a>`),
                        (o += `<div class="mini-cart__item-content"><div class="mini-cart__item-title" data-price="${n.final_price}" ><a href="${n.url || "/cart"}">${n.title}</a>`),
                        n.selling_plan_allocation && (o += `<div class="meta">${n.selling_plan_allocation.selling_plan.name}</div>`),
                        n.properties &&
                            $.each(n.properties, (t, e) => {
                                e && t.charAt(0) !== "_" && (o += `<div class="line-item">${t}: ${e} </div>`);
                            }),
                        (o += '</div><div class="mini-cart__item-price">'),
                        n.handle && $.ajax({
                            dataType: "json",
                            async: !1,
                            cache: !1,
                            url: `/products/${n.handle}.js`,
                            success(t) {
                                let e = t;
                                if (e.variants) {
                                    const t = e.variants;
                                    if (t.length > 1) for (let i = 0; i < t.length; i++) t[i].id === n.id && (e = t[i]);
                                }
                                e.compare_at_price && e.compare_at_price > e.price ? ((c = !0), (d = e.compare_at_price), (l = e.price)) : (c = !1);
                            },
                        }),
                        !0 === c)
                    ) { const t1 = `${window.Shopify.formatMoney(n.final_price, $("body").data("money-format"))} </span><span class="money was_price">${window.Shopify.formatMoney(d, $("body").data("money-format"))}</span>`;
                        //const t = `${window.Shopify.formatMoney(l, $("body").data("money-format"))} </span><span class="money was_price">${window.Shopify.formatMoney(d, $("body").data("money-format"))}</span>`;
                        (o += `<span class="money sale">${t1}</strong>`), (i = (d - l) * n.quantity), (e = i + e);
                      console.log(t1);
                    } else if (n.price > n.final_price) {
                        const t = `${window.Shopify.formatMoney(n.final_price, $("body").data("money-format"))} </span><span class="money was_price">${window.Shopify.formatMoney(n.price, $("body").data("money-format"))}</span>`;
                        o += `<span class="money sale">${t}</strong>`;
                    } else {
                        const t = window.Shopify.formatMoney(n.price, $("body").data("money-format"));
                        n.price > 0 ? (o += `<span class="money">${t}</span></strong>`) : (o += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`);
                    }
                    if (((o += "</div>"), n.unit_price_measurement && n.price > 0)) {
                        let t = "";
                        1 !== n.unit_price_measurement.reference_value && (t = n.unit_price_measurement.reference_value),
                            (o += `<p class="mini-cart__unit-price">${n.unit_price_measurement.quantity_value}${n.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(n.unit_price, $("body").data("money-format"))} / ${t}${
                                n.unit_price_measurement.reference_unit
                            }</p>`);
                    }
                    n.price > n.final_price && (o += s),
                        (o += '<div class="product-quantity-box">'),
                        (o += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>'),
                        (o += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${n.id}" value="${n.quantity}" data-cart-quantity-input="mini-cart" />`),
                        (o += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>'),
                        (o += "</div></div></div>"),
                        (o += `<a href="/cart/change?line=${r}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${r}" data-remove-item="mini-cart"><span class="remove-icon1"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M2165 4684 c-120 -26 -209 -76 -300 -168 -73 -74 -90 -99 -185 -278 l-105 -197 -312 -3 c-297 -3 -313 -4 -339 -24 -47 -35 -67 -70 -72 -128 -5 -66 23 -125 78 -159 l35 -22 1595 0 1595 0 35 22 c55 34 83 93 78 159 -5 58 -25 93 -72 128 -26 20 -42 21 -339 24 l-312 3 -105 197 c-95 178 -113 204 -185 278 -93 94 -181 142 -307 168 -107 22 -679 22 -783 0z m778 -354 c27 -13 62 -39 77 -57 26 -29 109 -172 125 -215 7 -17 -25 -18 -584 -18 -325 0 -591 3 -591 6 0 14 103 196 127 225 25 29 83 64 133 80 14 4 169 7 345 6 319 -2 320 -2 368 -27z"/><path d="M1211 3380 c-55 -13 -81 -32 -109 -80 l-27 -45 0 -710 c0 -741 5 -868 55 -1430 21 -232 38 -304 95 -400 73 -122 181 -208 325 -259 l85 -31 925 0 925 0 80 27 c186 64 330 208 386 388 22 69 43 280 76 740 15 209 18 382 18 965 l0 710 -27 46 c-32 55 -80 81 -148 81 -49 0 -94 -18 -121 -48 -44 -50 -43 -41 -40 -649 1 -319 -3 -683 -9 -810 -15 -324 -59 -883 -72 -925 -27 -85 -101 -156 -188 -180 -47 -13 -1713 -13 -1760 0 -87 24 -161 95 -188 180 -13 42 -57 601 -72 925 -6 127 -10 491 -9 810 3 515 1 583 -13 610 -36 68 -110 102 -187 85z"/></g></svg></span></a></span></a>`);
                });
                const p = t.cart_level_discount_applications;
                for (let t = 0; t < p.length; t++) {
                    const e = window.Shopify.formatMoney(p[t].total_allocated_amount, $("body").data("money-format")),
                        { title: i } = p[t];
                    (n += `<span class="cart_discounts--title">${i}</span>`), (n += '<span class="cart_discounts--price">'), (n += `-<span class="money">${e}</span></span>`);
                }
                (a += `<span class="right"><span class="money">${window.Shopify.formatMoney(t.total_price, $("body").data("money-format"))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`),
                    (e += t.total_discount),
                    (s =
                        window.PXUTheme.theme_settings.display_savings && e > 0
                            ? `<span class="right"><span class="money">${window.Shopify.formatMoney(e, $("body").data("money-format"))}</span></span><span>${window.PXUTheme.translation.cart_savings_text}</span>`
                            : "");
            }
            $(".js-cart_items").html(o), $(".js-cart_discounts").html(n), $(".js-cart_subtotal").html(a), $(".js-cart_savings").html(s), window.PXUTheme.currency.show_multiple_currencies && window.currencyConverter.convertCurrencies();
        }
  
  $('.quote-add-to-cart').click(function(e){
    
    e.preventDefault();
$('html, body').animate({scrollTop: 0}, 800);
    var formData = new FormData();
    console.log('check'+formData)
    var iv = 0;
    var variantData = [];
    var propertiesData = [];
    const bundlePayload = isBundleMode() ? buildBundlePayload() : null;
    const bundleSummaryLines = bundlePayload ? buildBundleSummaryLines(bundlePayload) : [];
    let bundlePayloadAttached = false;
    if (bundlePayload) {
      const totalBundleQty = bundlePayload.items.reduce((acc, item) => acc + (item.totalQty || 0), 0);
      if (!totalBundleQty) {
        alert('Please add quantities for each bundle item before adding to cart.');
        return;
      }
    }

    $(products).each(function(i, v){
        Object.keys(v.qty).forEach(function(key) {
            if(v.qty[key]){
              var s = key;
              var qty = v.qty[key];
              var varnt = v.variants.find(b=> (b.option1 == v.color && b.option2 == s));
              if (!varnt) {
                return;
              }
              var p = varnt.price / 100;
              variantData.push({id: varnt.id, qty: qty, price: p, name: v.title});
              formData.append('items['+iv+'][id]', varnt.id);
              formData.append('items['+iv+'][quantity]', qty);
              
              // V4: Check if this is an accessory item (hats, tumblers) - they should NOT show customization cost
              const isAccessoryProduct = bundleConfig && bundleConfig.items && bundleConfig.items.find(cfg => {
                return v.title && v.title.toLowerCase().includes(cfg.id) && isAccessoryItem(cfg);
              });
              
              // Only add 'bundle' property for apparel items (not accessories)
              if (!isAccessoryProduct) {
                formData.append('items['+iv+'][properties][bundle]', 'true');
              }
              formData.append('items['+iv+'][properties][_payload]', JSON.stringify(payload));
              
              formData.append('items['+iv+'][properties][_perunit]', products[0].price);
              formData.append('items['+iv+'][properties][_requestPrice]', requestPrice);
              if (bundlePayload && !bundlePayloadAttached) {
                formData.append('items['+iv+'][properties][_bundle_payload]', JSON.stringify(bundlePayload));
                bundleSummaryLines.forEach((line, idx) => {
                  formData.append('items['+iv+'][properties][Bundle Item '+(idx + 1)+']', line);
                });
                bundlePayloadAttached = true;
              }
              if (v.patchSelection) {
                formData.append(
                  'items['+iv+'][properties][Patch]',
                  `${v.patchSelection.color} • ${v.patchSelection.shape === 'circle' ? 'Circle' : 'Rectangle'} ${v.patchSelection.sizeLabel || ''}`
                );
              }
              if ($('#imageUpload')[0].files.length) {
                for (let f = 0; f < $('#imageUpload')[0].files.length; f++) {
                  formData.append('items['+iv+'][properties][file '+(f+1)+']', $('#imageUpload')[0].files[f]);
                }
              }

              // V3: Always screen printing
              formData.append('items['+iv+'][properties][Type]', 'Screen Printing');
              if (maxFront) {
                formData.append('items['+iv+'][properties][Front colors]', maxFront);
                const frontLocation = $("#frontLocation").val();
                if (frontLocation) {
                  formData.append('items['+iv+'][properties][Front Location]', frontLocation);
                }
              }
              if (maxBack) {
                formData.append('items['+iv+'][properties][Back colors]', maxBack);
                const backLocation = $("#backLocation").val();
                if (backLocation) {
                  formData.append('items['+iv+'][properties][Back Location]', backLocation);
                }
              }
              if (superRushProduction) {
                formData.append('items['+iv+'][properties][Production Timeline]', 'Super Rush (1 Day)');
                formData.append('items['+iv+'][properties][Rush Fee]', '$' + superRushFeePerUnit.toFixed(2) + ' per unit');
              } else if (rushProduction) {
                formData.append('items['+iv+'][properties][Production Timeline]', 'Rush (2-3 Business Days)');
                formData.append('items['+iv+'][properties][Rush Fee]', '$' + rushFeePerUnit.toFixed(2) + ' per unit');
              } else {
                formData.append('items['+iv+'][properties][Production Timeline]', 'Standard (7-10 Business Days)');
              }
              
              const orderNotes = $('#order_notes').val();
              if (orderNotes && orderNotes.trim() !== '') {
                formData.append('items['+iv+'][properties][Order Notes]', orderNotes.trim());
              }
          
              iv++;
            }
        })
    });

    // V3: If bundle add-on (48 tumblers) is checked, add with logo files
    try {
      var bundleChecked = jQuery('#bundle_addon_checkbox').length && jQuery('#bundle_addon_checkbox').is(':checked');
      if (bundleChecked) {
        var bundleVariantIdText = jQuery('#bundle_addon_variant_id').text() || '';
        var bundleVariantId = bundleVariantIdText.replace(/[^0-9]/g, '');
        if (bundleVariantId) {
          formData.append('items['+iv+'][id]', bundleVariantId);
          formData.append('items['+iv+'][quantity]', 1); // 1 = 48-pack
          formData.append('items['+iv+'][properties][_bundle_addon]', 'true');
          formData.append('items['+iv+'][properties][Bundled with Apparel]', 'Yes');
          formData.append('items['+iv+'][properties][Type]', 'Laser Engraved');
          formData.append('items['+iv+'][properties][Colors]', '1-color (same as apparel)');
          
          // V3: Pass the same logo files to tumbler line item
          if ($('#imageUpload')[0].files.length) {
            for (let f = 0; f < $('#imageUpload')[0].files.length; f++) {
              formData.append('items['+iv+'][properties][file '+(f+1)+']', $('#imageUpload')[0].files[f]);
            }
          }
          
          iv++;
        }
      }
    } catch(e) {
      console.log('V3 Bundle add-on handling error:', e);
    }

    // V3: If optional add-on is enabled and checked, add it as a separate line item
    try {
      var addonChecked = jQuery('#quote_addon').length && jQuery('#quote_addon').is(':checked');
      if (addonChecked) {
        var addonVariantIdText = jQuery('#quote_addon_variant_id').text() || '';
        var addonVariantId = addonVariantIdText.replace(/[^0-9]/g, '');
        var addonQty = 1; // Always 1 for add-on
        if (addonVariantId && addonQty > 0) {
          formData.append('items['+iv+'][id]', addonVariantId);
          formData.append('items['+iv+'][quantity]', addonQty);
          // Do NOT mark as bundle to avoid "Customization Cost" item
          formData.append('items['+iv+'][properties][_addon]', 'true');
          iv++;
        }
      }
    } catch(e) {
      console.log('V3 Add-on handling error:', e);
    }


    // formData.append('files_count', $('#imageUpload')[0].files.length);
    // if ($('#imageUpload')[0].files.length) {
    //   for (let f = 0; f < $('#imageUpload')[0].files.length; f++) {
    //     formData.append('files_'+(f+1), $('#imageUpload')[0].files[f]);
    //   }
    // }
    // formData.append('variantData', JSON.stringify(variantData));
    // formData.append('propertiesData', JSON.stringify(propertiesData));
    // formData.append('payload', payload.encryptedData);
    // formData.append('iv', payload.iv);
    console.log(formData);

    //return false;
    $(".spinner-border").show();
    $("button.btn-next.quote-add-to-cart.navigable span").hide();
    $("button.btn-next.quote-add-to-cart.navigable").attr('disabled', true);
    $.getJSON('/cart.js', function(cart){
        var removeitem ={};
        cart.items.forEach(function(item) {
          if (item.product_id == meta.product.id) {
            removeitem[item.id] = 0;
          }
        });
        $.ajax({
            url: '/cart/update.js',
            type: 'post',
            data: {updates: removeitem},
            dataType: 'json',
            success: function(res){
              console.log("in console");          
              $.ajax({
                     url : '/cart/add.js',
                     // url: 'https://kodiakapps.com/price-calc/backend/api/cart',
                     type : 'POST',
                     data : formData,
                     processData: false,  // tell jQuery not to process the data
                     contentType: false,  // tell jQuery not to set contentType
                     success : function(data) {
                          //window.location.href='/cart';
                       // window.location.href=data.order.draft_order.invoice_url;
                      jQuery.getJSON('/cart.js', function(cart) {
                          
                        closeQuoteModal();
                        $(".spinner-border").hide();
                        $("button.btn-next.quote-add-to-cart.navigable span").show();
                        $("button.btn-next.quote-add-to-cart.navigable").removeAttr('disabled');
                        navigateToTab('#pills-design');
                        refreshCart(cart);

                        $('.header .cart-container').addClass('active_link');
                        $('.cart-container.mobile-1').addClass('active_link');
                        $('.header .cart-container .cart_content').show(); 
                      
                        VastaShop.Cart.current = cart;

                        //render_cart_drawer(VastaShop.Cart.current, jQuery('.list-products'));
                       
                        render_cart_drawer(VastaShop.Cart.current, jQuery('ul.cart_items.js-cart_items'));
                       
                       //update_shipping_bar(cart.total_price,cart.item_count);
                      // jQuery('body').addClass('cart-drawer-open cart-open');
                      })
                     },
                  error: function (data) {
                    console.log('not-'+data);
                  }
              });
            }
        });
    })

  });
  
  $("#step2-btn").click(function(e){
    e.preventDefault();
    
    // V3: Simplified validation - always screen printing
    var flag = false;
    if (parseInt($("#colorFront").val()) > 0 || parseInt($("#colorBack").val()) > 0){
       flag = true;
      $('div#choose-colors .invalid-feedback').hide()
    }else{
       flag = false;
       $('div#choose-colors .invalid-feedback').show()
      return; // Don't proceed if no colors selected
    }
    
    // V3: Proceed to next step
    $("#pills-qty-tab").prop('disabled', false);
    navigateToTab('#pills-qty');
  });


  
});


// V3: Updated to use v3 endpoint
function getQuote(data) {
  // V4: Try v4 endpoint first, fallback to v3 if not available
  $.ajax({
    "url":"https://kodiakapps.com/price-calc/backend/api/v4/quote-price", // V4 endpoint
    "type":"post",
    "dataType": "json",
    "data": data,
    "success": function(res){
      if(res.length){
          const productIndex = products.findIndex((item) => item.id == res[0].pid);
          products[productIndex].price = parseFloat(res[0].per_unit);
          drawProductsListReview(products);
          updateGrandTotal(); // V3: Update grand total
      }
    },
    "error": function(){
      console.log("V4: getQuote() trying v3 fallback");
      // V4: Fallback to v3
      $.ajax({
        "url":"https://kodiakapps.com/price-calc/backend/api/v3/quote-price",
        "type":"post",
        "dataType": "json",
        "data": data,
        "success": function(res){
          if(res.length){
            const productIndex = products.findIndex((item) => item.id == res[0].pid);
            products[productIndex].price = parseFloat(res[0].per_unit);
            drawProductsListReview(products);
            updateGrandTotal();
          }
        }
      });
    }
  });
}

function previewSaveMore() {
  var s_calc_price  = 0;
  var s_price  = 0;
  var s_qty = 0;
  var s_front = maxFront;
  var s_back = maxBack;
  var s_sleeveLeft=sleeveLeft;
  var s_sleeveRight=sleeveRight;
  // for (let index = 0; index < products.length; index++) {
  //   s_front = parseInt(products[index].front);
  //   s_back = parseInt(products[index].back);
  //   s_sleeveLeft = parseInt(products[index].sleeveLeft);
  //   s_sleeveRight = parseInt(products[index].sleeveRight);
  // }

  // V4: When in bundle mode, exclude accessories (hats, tumblers) from qty calculation
  if (isBundleMode()) {
    const apparelProducts = products.filter((prod) => {
      // Find the corresponding config item
      const itemCfg = bundleConfig.items.find((cfg) => prod.title && prod.title.toLowerCase().includes(cfg.id));
      return itemCfg ? !isAccessoryItem(itemCfg) : true;
    });
    s_qty = apparelProducts.reduce((acc, { sumQty }) => acc + sumQty, 0);
    s_calc_price = apparelProducts.reduce(
      (acc, { sumQty, calc_price }) => acc + sumQty * calc_price,
      0
    );
  } else {
    s_qty = products.reduce((acc, { sumQty }) => acc + sumQty, 0);
    s_calc_price = products.reduce(
      (acc, { sumQty, calc_price }) => acc + sumQty * calc_price,
      0
    );
  }

  s_calc_price = s_calc_price/s_qty;
  requestPrice = s_calc_price;
  
  // V3/V4: Always screen printing, include rush/super_rush production and print locations
  var pType = 'Screen Printing';
  var params = {
    "qty": s_qty, 
    "price": s_calc_price, 
    "fcolor": s_front, 
    "bcolor": s_back, 
    "type": pType,
    "rush_production": rushProduction, // V3: Rush production flag
    "super_rush_production": superRushProduction, // V4: Super Rush production flag
    "front_location": s_front > 0 ? ($("#frontLocation").val() || 'Full Front') : '', // V3: Front print location
    "back_location": s_back > 0 ? ($("#backLocation").val() || 'Full Back') : '' // V3: Back print location
  };
  if (isBundleMode()) {
    const bundlePayload = buildBundlePayload();
    if (bundlePayload) {
      params.bundle_id = bundlePayload.bundle_id;
      const pricingItems = (bundlePayload.items || []).filter((item) => !isAccessoryItem(item));
      params.bundle_items = JSON.stringify(pricingItems);
    }
  }
  
  // V4: Try v4 endpoint first, fallback to v3 if not available
  const apiUrl = "https://kodiakapps.com/price-calc/backend/api/v4/quote-price";
  const fallbackUrl = "https://kodiakapps.com/price-calc/backend/api/v3/quote-price";
  
  $.ajax({
    "url": apiUrl,
    "type":"post",
    "dataType": "json",
    "data": params,
    "success": function(res){
      console.log("V4 API Response:", res); // V4: Debug logging
      $(".buy-more").remove();
     if(res.length>0){
       // V3: Update all products with the same averaged price
       for (let index = 0; index < products.length; index++) {
          products[index].price = parseFloat(res[0].per_unit);
       }
       payload =  res[0].payload;
       drawProductsListReview(products); // V3: Draw once after all products updated
       updateGrandTotal(); // V3: Update grand total after pricing
     }
      if(res.length>1){
          var sm_view = `<div class="buy-more"><strong>Buy More Save More!</strong>`;
          for (let sm = 1; sm < res.length; sm++) {
            sm_view += `<div class="row">
              <div class="col-6">
                Buy <strong>${ res[sm].qty - s_qty } More</strong> items and save $${ (res[0].per_unit - res[sm].per_unit).toFixed(2) } each
              </div>
              <div class="col-6 text-end">
                <strong>$${ res[sm].per_unit }</strong> each
              </div>
            </div>`;
          }
          sm_view += `</div>`;
        $('.affirm').after(sm_view);
      } else {
        console.log("V3: No tiered pricing returned (res.length = " + res.length + ")"); // V3: Debug
      }
    },
    "error": function(xhr, status, error){
      console.error("V4 API Error - trying fallback:", status, error); // V4: Error logging
      
      // V4: Fallback to v3 endpoint temporarily
      $.ajax({
        "url": fallbackUrl,
        "type":"post",
        "dataType": "json",
        "data": params,
        "success": function(res){
          console.log("V3: Using v2 fallback API, response:", res);
          $(".buy-more").remove();
          if(res.length>0){
            // V3: Update all products with the same averaged price
            for (let index = 0; index < products.length; index++) {
               products[index].price = parseFloat(res[0].per_unit);
            }
            payload =  res[0].payload;
            drawProductsListReview(products); // V3: Draw once after all products updated
            updateGrandTotal();
          }
          if(res.length>1){
            var sm_view = `<div class="buy-more"><strong>Buy More Save More!</strong>`;
            for (let sm = 1; sm < res.length; sm++) {
              sm_view += `<div class="row">
                <div class="col-6">
                  Buy <strong>${ res[sm].qty - s_qty } More</strong> items and save $${ (res[0].per_unit - res[sm].per_unit).toFixed(2) } each
                </div>
                <div class="col-6 text-end">
                  <strong>$${ res[sm].per_unit }</strong> each
                </div>
              </div>`;
            }
            sm_view += `</div>`;
            $('.affirm').after(sm_view);
          }
        },
        "error": function(xhr2, status2, error2){
          console.error("V3: Both v3 and v2 API failed:", status2, error2);
        }
      });
    }
  });
}

addEventListener("load", (event) => {
  console.log('V3: Page loaded, checking for editqty parameter...');
  console.log('V3: URL search:', window.location.search);
  if (window.location.search.includes('editqty')) {
    console.log('V3: editqty detected! Fetching cart data...');
    // V3: Use Shopify Cart API instead of VastaShop to avoid dependency issues
    $.getJSON('/cart.js', function(cart) {
      console.log('V3: Cart data received:', cart);
      window.bundle_dataTransfer = new DataTransfer();
      var current_items = [];
      cart.items.forEach(function(item) {
        if (item.product_id == meta.product.id) {
          current_items.push(item);
        }
      });
      console.log('V3: Found', current_items.length, 'items for this product');
      if(current_items.length){
      var pre_bundle = current_items[0];
      var properties = pre_bundle.properties;
      console.log('V3: Item properties:', properties);
      
      // V3/V4: Always screen printing, check for rush or super rush production
      if (properties["Production Timeline"]) {
        if (properties["Production Timeline"].includes("Super Rush")) {
          $('input[name="production_speed"][value="super_rush"]').prop('checked', true);
          superRushProduction = true;
          rushProduction = false;
        } else if (properties["Production Timeline"].includes("Rush")) {
          $('input[name="production_speed"][value="rush"]').prop('checked', true);
          rushProduction = true;
          superRushProduction = false;
        }
      }
      
      // V3: Restore order notes if present
      if (properties["Order Notes"]) {
        console.log('V3: Restoring Order Notes:', properties["Order Notes"]);
        $("#order_notes").val(properties["Order Notes"]);
      }

      if (properties["Front colors"]) {
        $("#colorFront").val(properties["Front colors"]).trigger('change');
      }

      if (properties["Back colors"]) {
        $("#colorBack").val(properties["Back colors"]).trigger('change');
      }

      // V3: Update print location visibility based on restored colors
      console.log('V3: Updating print location visibility...');
      updatePrintLocationVisibility();

      // V3: Restore print locations
      if (properties["Front Location"]) {
        console.log('V3: Restoring Front Location:', properties["Front Location"]);
        setLocationValue('#frontLocation', properties["Front Location"]);
      }

      if (properties["Back Location"]) {
        console.log('V3: Restoring Back Location:', properties["Back Location"]);
        const allowedBackLocations = ["Full Back", "Back Collar", "Upper Back"];
        const backValue = allowedBackLocations.includes(properties["Back Location"])
          ? properties["Back Location"]
          : "Upper Back";
        setLocationValue('#backLocation', backValue);
      }

      $("#step2-btn").trigger('click');
      window.file_length = Object.keys(current_items[0].properties).filter(x => x.includes('file')).length;
      window.file_count = 0;
      Object.keys(properties).forEach(async function(prop) {
        if (prop.includes("file")) {
          var file_url = properties[prop];
          await getFileFromUrl(file_url, prop);          
        }
      });


      current_items.forEach(function(itm) {
        var color = itm.variant_options[0];
        if($('.color-picker .color-item[data-color="'+color+'"]').hasClass('active') == false){
          $('.color-picker .color-item[data-color="'+color+'"]').trigger('click');
        }
        $('.sizes .sizes-input input[data-variant="'+itm.variant_id+'"]').val(itm.quantity).trigger('keyup')
        
      });

      var intvl = setInterval(function() {
        if (window.file_length == window.file_count) {
          var fileInput = document.querySelector('#imageUpload');
          fileInput.files = window.bundle_dataTransfer.files;
          PreviewImage();
          clearInterval(intvl);
        }
      }, 200)

      }
      console.log('V3: Current items:', current_items)
        var swatch = $('.gf_swatches-selector[data-name="Color"] .gf_swatch');
        swatch.each(function(){
            var clr = $(this).text();
            var styl = $(this).attr('style');
            $('color-item[data-color="'+clr+'"]').attr('style', styl);
        });

      console.log('V3: Opening modal...');
      prepareQuoteModalUI();
      openQuoteModal();
    }); // V3: Close $.getJSON callback
  }
});

async function getFileFromUrl(url, name, defaultType = 'image/png') {
  var response = await fetch(url)
  var data = await response.blob()
  var file = new File([data], name, {
    type: data.type || defaultType,
  });
  window.file_count++;
  window.bundle_dataTransfer.items.add(file);
  console.log(bundle_dataTransfer.files);
}

function removeFile(index){
    var attachments = document.querySelector('#imageUpload').files;
    var fileBuffer = new DataTransfer();

    // append the file list to an array iteratively
    for (let i = 0; i < attachments.length; i++) {
        // Exclude file in specified index
        if (index !== i)
            fileBuffer.items.add(attachments[i]);
    }
    
    // Assign buffer to file input
    document.querySelector('#imageUpload').files = fileBuffer.files;
    PreviewImage();
}

function syncColorDropdownSelections() {
  var frontColors = parseInt($("#colorFront").val()) || 0;
  var backColors = parseInt($("#colorBack").val()) || 0;
  chooseColorsFront(frontColors);
  chooseColorsBack(backColors);
}

function prepareQuoteModalUI() {
  var swatch = $('.gf_swatches-selector[data-name="Color"] .gf_swatch');
  swatch.each(function(){
      var clr = $(this).text();
      var styl = $(this).attr('style');
      $('.color-item[data-color="'+clr+'"]').attr('style', styl);
  });

  setTimeout(function() {
    syncColorDropdownSelections();
  }, 150);
}

function openQuoteModal() {
  $("#modal").addClass('is-visible').attr('aria-hidden', 'false');
  $('body').addClass('quote-modal-open');
  syncColorDropdownSelections();
}

function closeQuoteModal() {
  $("#modal").removeClass('is-visible').attr('aria-hidden', 'true');
  $('body').removeClass('quote-modal-open');
}

function internalShowQuoteTab(tabId) {
  if (!tabId) return;
  var $target = $(tabId);
  if (!$target.length) return;
  var $button = $(`[data-tab-target="${tabId}"]`);
  if ($button.length && $button.prop('disabled')) {
    return;
  }
  $('.tab-pane').removeClass('show active');
  $target.addClass('show active');
  $('.nav-link[data-tab-target]').removeClass('active').attr('aria-selected', 'false');
  if ($button.length) {
    $button.addClass('active').attr('aria-selected', 'true');
  }
}

function navigateToTab(tabId) {
  if (!tabId) return;
  if (tabId === '#pills-review') {
    if (!products.length) {
      return;
    }
    if (typeof previewSaveMore === 'function') {
      previewSaveMore();
    }
  }
  internalShowQuoteTab(tabId);
}

window.showQuoteTab = function(tabId) {
  navigateToTab(tabId);
};

function bindQuotePopupUI() {
  $(document).on('click', '.nav-link[data-tab-target]', function(e) {
    e.preventDefault();
    navigateToTab($(this).data('tab-target'));
  });

  $(document).on('click', '.quote-tab-trigger', function(e) {
    e.preventDefault();
    var target = $(this).data('tab-target');
    navigateToTab(target);
  });

  $(document).on('click', '.pricing-modal .btn-close', function(e) {
    e.preventDefault();
    closeQuoteModal();
  });

  $(document).on('click', '.pricing-modal', function(e) {
    if ($(e.target).is('.pricing-modal')) {
      closeQuoteModal();
    }
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
      closeQuoteModal();
    }
  });

  $(document).on('click', '.js-collapse-toggle', function(e) {
    e.preventDefault();
    var targetSelector = $(this).data('collapse-target');
    if (!targetSelector) return;
    var $target = $(targetSelector);
    if (!$target.length) return;
    var willShow = !$target.hasClass('show');
    $target.toggleClass('show', willShow);
    $(`[data-collapse-target="${targetSelector}"]`).toggleClass('collapsed', !willShow);
  });
}
